/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebhooksRouteImport } from './routes/webhooks'
import { Route as VoicesRouteImport } from './routes/voices'
import { Route as UsageRouteImport } from './routes/usage'
import { Route as UgcAiAvatarRouteImport } from './routes/ugc-ai-avatar'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StoryboardExplorationRouteImport } from './routes/storyboard-exploration'
import { Route as SocialAccountsRouteImport } from './routes/social-accounts'
import { Route as SignoutRouteImport } from './routes/signout'
import { Route as SentryBreakRouteImport } from './routes/sentry-break'
import { Route as ScheduleRouteImport } from './routes/schedule'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PdfRouteImport } from './routes/pdf'
import { Route as MediaSpaceRouteImport } from './routes/media-space'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as HooksRouteImport } from './routes/hooks'
import { Route as HomeRouteImport } from './routes/home'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as DevelopersRouteImport } from './routes/developers'
import { Route as DeletionRequestRouteImport } from './routes/deletion-request'
import { Route as CreatorRouteImport } from './routes/creator'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as BRollRouteImport } from './routes/b-roll'
import { Route as AutomatedCreateRouteImport } from './routes/automated-create'
import { Route as AutomatedRouteImport } from './routes/automated'
import { Route as AudioRouteImport } from './routes/audio'
import { Route as AssetLibraryRouteImport } from './routes/asset-library'
import { Route as ApiKeysRouteImport } from './routes/api-keys'
import { Route as AdLibraryRouteImport } from './routes/ad-library'
import { Route as AccountRouteImport } from './routes/account'
import { Route as R404RouteImport } from './routes/404'
import { Route as ModelSlugRouteImport } from './routes/$modelSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ViralIndexRouteImport } from './routes/viral/index'
import { Route as VideosIndexRouteImport } from './routes/videos/index'
import { Route as TutorialIndexRouteImport } from './routes/tutorial/index'
import { Route as ToolsIndexRouteImport } from './routes/tools/index'
import { Route as TemplatesIndexRouteImport } from './routes/templates/index'
import { Route as TeamIndexRouteImport } from './routes/team.index'
import { Route as SuccessStoriesIndexRouteImport } from './routes/success-stories/index'
import { Route as MediaSpaceIndexRouteImport } from './routes/media-space/index'
import { Route as CreateIndexRouteImport } from './routes/create.index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AuthIndexRouteImport } from './routes/auth/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ViralPricingRouteImport } from './routes/viral/pricing'
import { Route as VLinkIdRouteImport } from './routes/v/$linkId'
import { Route as ToolsVideoEffectsRouteImport } from './routes/tools/video-effects'
import { Route as ToolsVeo3GeneratorRouteImport } from './routes/tools/veo3-generator'
import { Route as ToolsStyleTransferRouteImport } from './routes/tools/style-transfer'
import { Route as ToolsScriptWriterRouteImport } from './routes/tools/script-writer'
import { Route as ToolsPromptHubRouteImport } from './routes/tools/prompt-hub'
import { Route as ToolsInfinitetalkDemoRouteImport } from './routes/tools/infinitetalk-demo'
import { Route as ToolsImageUpscalerRouteImport } from './routes/tools/image-upscaler'
import { Route as ToolsImageTransformerRouteImport } from './routes/tools/image-transformer'
import { Route as ToolsImageResizerRouteImport } from './routes/tools/image-resizer'
import { Route as ToolsBackgroundRemoverRouteImport } from './routes/tools/background-remover'
import { Route as ToolsAvatarLibraryRouteImport } from './routes/tools/avatar-library'
import { Route as ToolsAvatarAdGeneratorRouteImport } from './routes/tools/avatar-ad-generator'
import { Route as ToolsAssetLibraryRouteImport } from './routes/tools/asset-library'
import { Route as ToolsAiVoiceoverRouteImport } from './routes/tools/ai-voiceover'
import { Route as ToolsAiSoundEffectsRouteImport } from './routes/tools/ai-sound-effects'
import { Route as ToolsAiAvatarRouteImport } from './routes/tools/ai-avatar'
import { Route as ToolsAdScraperRouteImport } from './routes/tools/ad-scraper'
import { Route as ToolsIdRouteImport } from './routes/tools/$id'
import { Route as TemplatesRedditStoryRouteImport } from './routes/templates/reddit-story'
import { Route as TemplatesPovStoryRouteImport } from './routes/templates/pov-story'
import { Route as TemplatesGenzAvatarsRouteImport } from './routes/templates/genz-avatars'
import { Route as TemplatesFakeTextRouteImport } from './routes/templates/fake-text'
import { Route as TemplatesAiStoryRouteImport } from './routes/templates/ai-story'
import { Route as TeamInviteRouteImport } from './routes/team.invite'
import { Route as SeriesSeriesIdRouteImport } from './routes/series/$seriesId'
import { Route as MediaSpaceWorkflowsRouteImport } from './routes/media-space/workflows'
import { Route as MediaSpaceBoardsRouteImport } from './routes/media-space/boards'
import { Route as EmbedEditRouteImport } from './routes/embed/edit'
import { Route as CreateVideoRouteImport } from './routes/create/video'
import { Route as CreateUgcTemplatesRouteImport } from './routes/create/ugc-templates'
import { Route as CreateUgcAvatarsRouteImport } from './routes/create/ugc-avatars'
import { Route as CreateUgcRouteImport } from './routes/create/ugc'
import { Route as CreateImageRouteImport } from './routes/create/image'
import { Route as CreateEditRouteImport } from './routes/create/edit'
import { Route as CreateCaptionsRouteImport } from './routes/create/captions'
import { Route as CreateAudioRouteImport } from './routes/create/audio'
import { Route as CreateAdStudioRouteImport } from './routes/create/ad-studio'
import { Route as BlogAdminRouteImport } from './routes/blog/admin'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as AuthVerifyRouteImport } from './routes/auth.verify'
import { Route as AuthSignoutRouteImport } from './routes/auth/signout'
import { Route as AuthSigninRouteImport } from './routes/auth.signin'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AssetLibraryAssetIdRouteImport } from './routes/asset-library.$assetId'
import { Route as AdsStaticRouteImport } from './routes/ads/static'
import { Route as AdminVoicesRouteImport } from './routes/admin/voices'
import { Route as AdminVideosRouteImport } from './routes/admin/videos'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminToolsRouteImport } from './routes/admin/tools'
import { Route as AdminTeamsRouteImport } from './routes/admin/teams'
import { Route as AdminStaticAdsRouteImport } from './routes/admin/static-ads'
import { Route as AdminSigninRouteImport } from './routes/admin/signin'
import { Route as AdminSeriesRouteImport } from './routes/admin/series'
import { Route as AdminScheduledPostsRouteImport } from './routes/admin/scheduledPosts'
import { Route as AdminRenderLabRouteImport } from './routes/admin/render-lab'
import { Route as AdminProductsRouteImport } from './routes/admin/products'
import { Route as AdminPresetsRouteImport } from './routes/admin/presets'
import { Route as AdminPipelinesRouteImport } from './routes/admin/pipelines'
import { Route as AdminModelRegistryRouteImport } from './routes/admin/model-registry'
import { Route as AdminModelPricingRouteImport } from './routes/admin/model-pricing'
import { Route as AdminMastraRouteImport } from './routes/admin/mastra'
import { Route as AdminKevRouteImport } from './routes/admin/kev'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as AdminExperimentsRouteImport } from './routes/admin/experiments'
import { Route as AdminEvalsRouteImport } from './routes/admin/evals'
import { Route as AdminEmailRouteImport } from './routes/admin/email'
import { Route as AdminEditorEffectsRouteImport } from './routes/admin/editor-effects'
import { Route as AdminContentSeedsRouteImport } from './routes/admin/content-seeds'
import { Route as AdminBrandsRouteImport } from './routes/admin/brands'
import { Route as AdminBenchmarksRouteImport } from './routes/admin/benchmarks'
import { Route as AdminAvatarsRouteImport } from './routes/admin/avatars'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminAssetsRouteImport } from './routes/admin/assets'
import { Route as AdminAssetJobsRouteImport } from './routes/admin/asset-jobs'
import { Route as AdminAdsPerformanceRouteImport } from './routes/admin/ads-performance'
import { Route as AdminAdLibraryRouteImport } from './routes/admin/ad-library'
import { Route as AdLibraryAdIdRouteImport } from './routes/ad-library.$adId'
import { Route as VideosVideoIdIndexRouteImport } from './routes/videos/$videoId/index'
import { Route as PrototypesSocialMonitorIndexRouteImport } from './routes/prototypes/social-monitor/index'
import { Route as PrototypesManwhaIndexRouteImport } from './routes/prototypes/manwha/index'
import { Route as PrototypesImageEditorIndexRouteImport } from './routes/prototypes/image-editor/index'
import { Route as PrototypesCarouselsIndexRouteImport } from './routes/prototypes/carousels/index'
import { Route as AdminAdEngineIndexRouteImport } from './routes/admin/ad-engine.index'
import { Route as VideosVideoIdStoryboardRouteImport } from './routes/videos/$videoId/storyboard'
import { Route as VideosVideoIdEditorRouteImport } from './routes/videos/$videoId/editor'
import { Route as VideosVideoIdDebugRouteImport } from './routes/videos/$videoId/debug'
import { Route as PrototypesImageEditorImageEditIdRouteImport } from './routes/prototypes/image-editor/$imageEditId'
import { Route as PrototypesCarouselsCarouselIdRouteImport } from './routes/prototypes/carousels/$carouselId'
import { Route as MediaSpaceBoardBoardIdRouteImport } from './routes/media-space/board.$boardId'
import { Route as MediaSpaceAssetAssetIdRouteImport } from './routes/media-space/asset.$assetId'
import { Route as CreateCaptionsVideoIdRouteImport } from './routes/create/captions.$videoId'
import { Route as AuthErrorSplatRouteImport } from './routes/auth/error/$'
import { Route as AdminTraceVideoIdRouteImport } from './routes/admin/trace.$videoId'
import { Route as AdminTeamIdRouteImport } from './routes/admin/team/$id'
import { Route as AdminPipelinesExecutionIdRouteImport } from './routes/admin/pipelines.$executionId'
import { Route as AdminAssetJobsIdRouteImport } from './routes/admin/asset-jobs.$id'
import { Route as AdminAdsPerformanceMetaCallbackRouteImport } from './routes/admin/ads-performance.meta-callback'
import { Route as AdminAdEngineReviewRouteImport } from './routes/admin/ad-engine.review'
import { Route as AdminAdEngineFormatsRouteImport } from './routes/admin/ad-engine.formats'
import { Route as AdminAdEngineVideoIdRouteImport } from './routes/admin/ad-engine.$videoId'
import { Route as VideosVideoIdEditorIndexRouteImport } from './routes/videos/$videoId/editor/index'
import { Route as VideosVideoIdEditorRedditStoryRouteImport } from './routes/videos/$videoId/editor/reddit-story'
import { Route as VideosVideoIdEditorGenzAvatarsRouteImport } from './routes/videos/$videoId/editor/genz-avatars'
import { Route as VideosVideoIdEditorFakeTextRouteImport } from './routes/videos/$videoId/editor/fake-text'

const WebhooksRoute = WebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => rootRouteImport,
} as any)
const VoicesRoute = VoicesRouteImport.update({
  id: '/voices',
  path: '/voices',
  getParentRoute: () => rootRouteImport,
} as any)
const UsageRoute = UsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => rootRouteImport,
} as any)
const UgcAiAvatarRoute = UgcAiAvatarRouteImport.update({
  id: '/ugc-ai-avatar',
  path: '/ugc-ai-avatar',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const StoryboardExplorationRoute = StoryboardExplorationRouteImport.update({
  id: '/storyboard-exploration',
  path: '/storyboard-exploration',
  getParentRoute: () => rootRouteImport,
} as any)
const SocialAccountsRoute = SocialAccountsRouteImport.update({
  id: '/social-accounts',
  path: '/social-accounts',
  getParentRoute: () => rootRouteImport,
} as any)
const SignoutRoute = SignoutRouteImport.update({
  id: '/signout',
  path: '/signout',
  getParentRoute: () => rootRouteImport,
} as any)
const SentryBreakRoute = SentryBreakRouteImport.update({
  id: '/sentry-break',
  path: '/sentry-break',
  getParentRoute: () => rootRouteImport,
} as any)
const ScheduleRoute = ScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const PdfRoute = PdfRouteImport.update({
  id: '/pdf',
  path: '/pdf',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaSpaceRoute = MediaSpaceRouteImport.update({
  id: '/media-space',
  path: '/media-space',
  getParentRoute: () => rootRouteImport,
} as any)
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRouteImport,
} as any)
const HooksRoute = HooksRouteImport.update({
  id: '/hooks',
  path: '/hooks',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const DevelopersRoute = DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const DeletionRequestRoute = DeletionRequestRouteImport.update({
  id: '/deletion-request',
  path: '/deletion-request',
  getParentRoute: () => rootRouteImport,
} as any)
const CreatorRoute = CreatorRouteImport.update({
  id: '/creator',
  path: '/creator',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const BRollRoute = BRollRouteImport.update({
  id: '/b-roll',
  path: '/b-roll',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomatedCreateRoute = AutomatedCreateRouteImport.update({
  id: '/automated-create',
  path: '/automated-create',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomatedRoute = AutomatedRouteImport.update({
  id: '/automated',
  path: '/automated',
  getParentRoute: () => rootRouteImport,
} as any)
const AudioRoute = AudioRouteImport.update({
  id: '/audio',
  path: '/audio',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetLibraryRoute = AssetLibraryRouteImport.update({
  id: '/asset-library',
  path: '/asset-library',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiKeysRoute = ApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const AdLibraryRoute = AdLibraryRouteImport.update({
  id: '/ad-library',
  path: '/ad-library',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const ModelSlugRoute = ModelSlugRouteImport.update({
  id: '/$modelSlug',
  path: '/$modelSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViralIndexRoute = ViralIndexRouteImport.update({
  id: '/viral/',
  path: '/viral/',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosIndexRoute = VideosIndexRouteImport.update({
  id: '/videos/',
  path: '/videos/',
  getParentRoute: () => rootRouteImport,
} as any)
const TutorialIndexRoute = TutorialIndexRouteImport.update({
  id: '/tutorial/',
  path: '/tutorial/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsIndexRoute = ToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesIndexRoute = TemplatesIndexRouteImport.update({
  id: '/templates/',
  path: '/templates/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuccessStoriesIndexRoute = SuccessStoriesIndexRouteImport.update({
  id: '/success-stories/',
  path: '/success-stories/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaSpaceIndexRoute = MediaSpaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MediaSpaceRoute,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViralPricingRoute = ViralPricingRouteImport.update({
  id: '/viral/pricing',
  path: '/viral/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const VLinkIdRoute = VLinkIdRouteImport.update({
  id: '/v/$linkId',
  path: '/v/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsVideoEffectsRoute = ToolsVideoEffectsRouteImport.update({
  id: '/tools/video-effects',
  path: '/tools/video-effects',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsVeo3GeneratorRoute = ToolsVeo3GeneratorRouteImport.update({
  id: '/tools/veo3-generator',
  path: '/tools/veo3-generator',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsStyleTransferRoute = ToolsStyleTransferRouteImport.update({
  id: '/tools/style-transfer',
  path: '/tools/style-transfer',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsScriptWriterRoute = ToolsScriptWriterRouteImport.update({
  id: '/tools/script-writer',
  path: '/tools/script-writer',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsPromptHubRoute = ToolsPromptHubRouteImport.update({
  id: '/tools/prompt-hub',
  path: '/tools/prompt-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsInfinitetalkDemoRoute = ToolsInfinitetalkDemoRouteImport.update({
  id: '/tools/infinitetalk-demo',
  path: '/tools/infinitetalk-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsImageUpscalerRoute = ToolsImageUpscalerRouteImport.update({
  id: '/tools/image-upscaler',
  path: '/tools/image-upscaler',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsImageTransformerRoute = ToolsImageTransformerRouteImport.update({
  id: '/tools/image-transformer',
  path: '/tools/image-transformer',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsImageResizerRoute = ToolsImageResizerRouteImport.update({
  id: '/tools/image-resizer',
  path: '/tools/image-resizer',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsBackgroundRemoverRoute = ToolsBackgroundRemoverRouteImport.update({
  id: '/tools/background-remover',
  path: '/tools/background-remover',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAvatarLibraryRoute = ToolsAvatarLibraryRouteImport.update({
  id: '/tools/avatar-library',
  path: '/tools/avatar-library',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAvatarAdGeneratorRoute = ToolsAvatarAdGeneratorRouteImport.update({
  id: '/tools/avatar-ad-generator',
  path: '/tools/avatar-ad-generator',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAssetLibraryRoute = ToolsAssetLibraryRouteImport.update({
  id: '/tools/asset-library',
  path: '/tools/asset-library',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAiVoiceoverRoute = ToolsAiVoiceoverRouteImport.update({
  id: '/tools/ai-voiceover',
  path: '/tools/ai-voiceover',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAiSoundEffectsRoute = ToolsAiSoundEffectsRouteImport.update({
  id: '/tools/ai-sound-effects',
  path: '/tools/ai-sound-effects',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAiAvatarRoute = ToolsAiAvatarRouteImport.update({
  id: '/tools/ai-avatar',
  path: '/tools/ai-avatar',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsAdScraperRoute = ToolsAdScraperRouteImport.update({
  id: '/tools/ad-scraper',
  path: '/tools/ad-scraper',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsIdRoute = ToolsIdRouteImport.update({
  id: '/tools/$id',
  path: '/tools/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesRedditStoryRoute = TemplatesRedditStoryRouteImport.update({
  id: '/templates/reddit-story',
  path: '/templates/reddit-story',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesPovStoryRoute = TemplatesPovStoryRouteImport.update({
  id: '/templates/pov-story',
  path: '/templates/pov-story',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesGenzAvatarsRoute = TemplatesGenzAvatarsRouteImport.update({
  id: '/templates/genz-avatars',
  path: '/templates/genz-avatars',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesFakeTextRoute = TemplatesFakeTextRouteImport.update({
  id: '/templates/fake-text',
  path: '/templates/fake-text',
  getParentRoute: () => rootRouteImport,
} as any)
const TemplatesAiStoryRoute = TemplatesAiStoryRouteImport.update({
  id: '/templates/ai-story',
  path: '/templates/ai-story',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamInviteRoute = TeamInviteRouteImport.update({
  id: '/team/invite',
  path: '/team/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const SeriesSeriesIdRoute = SeriesSeriesIdRouteImport.update({
  id: '/series/$seriesId',
  path: '/series/$seriesId',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaSpaceWorkflowsRoute = MediaSpaceWorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => MediaSpaceRoute,
} as any)
const MediaSpaceBoardsRoute = MediaSpaceBoardsRouteImport.update({
  id: '/boards',
  path: '/boards',
  getParentRoute: () => MediaSpaceRoute,
} as any)
const EmbedEditRoute = EmbedEditRouteImport.update({
  id: '/embed/edit',
  path: '/embed/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateVideoRoute = CreateVideoRouteImport.update({
  id: '/create/video',
  path: '/create/video',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateUgcTemplatesRoute = CreateUgcTemplatesRouteImport.update({
  id: '/create/ugc-templates',
  path: '/create/ugc-templates',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateUgcAvatarsRoute = CreateUgcAvatarsRouteImport.update({
  id: '/create/ugc-avatars',
  path: '/create/ugc-avatars',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateUgcRoute = CreateUgcRouteImport.update({
  id: '/create/ugc',
  path: '/create/ugc',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateImageRoute = CreateImageRouteImport.update({
  id: '/create/image',
  path: '/create/image',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateEditRoute = CreateEditRouteImport.update({
  id: '/create/edit',
  path: '/create/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateCaptionsRoute = CreateCaptionsRouteImport.update({
  id: '/create/captions',
  path: '/create/captions',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAudioRoute = CreateAudioRouteImport.update({
  id: '/create/audio',
  path: '/create/audio',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateAdStudioRoute = CreateAdStudioRouteImport.update({
  id: '/create/ad-studio',
  path: '/create/ad-studio',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogAdminRoute = BlogAdminRouteImport.update({
  id: '/blog/admin',
  path: '/blog/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignoutRoute = AuthSignoutRouteImport.update({
  id: '/auth/signout',
  path: '/auth/signout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/auth/signin',
  path: '/auth/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetLibraryAssetIdRoute = AssetLibraryAssetIdRouteImport.update({
  id: '/$assetId',
  path: '/$assetId',
  getParentRoute: () => AssetLibraryRoute,
} as any)
const AdsStaticRoute = AdsStaticRouteImport.update({
  id: '/ads/static',
  path: '/ads/static',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVoicesRoute = AdminVoicesRouteImport.update({
  id: '/admin/voices',
  path: '/admin/voices',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVideosRoute = AdminVideosRouteImport.update({
  id: '/admin/videos',
  path: '/admin/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminToolsRoute = AdminToolsRouteImport.update({
  id: '/admin/tools',
  path: '/admin/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeamsRoute = AdminTeamsRouteImport.update({
  id: '/admin/teams',
  path: '/admin/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStaticAdsRoute = AdminStaticAdsRouteImport.update({
  id: '/admin/static-ads',
  path: '/admin/static-ads',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSigninRoute = AdminSigninRouteImport.update({
  id: '/admin/signin',
  path: '/admin/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSeriesRoute = AdminSeriesRouteImport.update({
  id: '/admin/series',
  path: '/admin/series',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminScheduledPostsRoute = AdminScheduledPostsRouteImport.update({
  id: '/admin/scheduledPosts',
  path: '/admin/scheduledPosts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRenderLabRoute = AdminRenderLabRouteImport.update({
  id: '/admin/render-lab',
  path: '/admin/render-lab',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/admin/products',
  path: '/admin/products',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPresetsRoute = AdminPresetsRouteImport.update({
  id: '/admin/presets',
  path: '/admin/presets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPipelinesRoute = AdminPipelinesRouteImport.update({
  id: '/admin/pipelines',
  path: '/admin/pipelines',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModelRegistryRoute = AdminModelRegistryRouteImport.update({
  id: '/admin/model-registry',
  path: '/admin/model-registry',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModelPricingRoute = AdminModelPricingRouteImport.update({
  id: '/admin/model-pricing',
  path: '/admin/model-pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMastraRoute = AdminMastraRouteImport.update({
  id: '/admin/mastra',
  path: '/admin/mastra',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKevRoute = AdminKevRouteImport.update({
  id: '/admin/kev',
  path: '/admin/kev',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
  id: '/admin/feedback',
  path: '/admin/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminExperimentsRoute = AdminExperimentsRouteImport.update({
  id: '/admin/experiments',
  path: '/admin/experiments',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEvalsRoute = AdminEvalsRouteImport.update({
  id: '/admin/evals',
  path: '/admin/evals',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailRoute = AdminEmailRouteImport.update({
  id: '/admin/email',
  path: '/admin/email',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEditorEffectsRoute = AdminEditorEffectsRouteImport.update({
  id: '/admin/editor-effects',
  path: '/admin/editor-effects',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContentSeedsRoute = AdminContentSeedsRouteImport.update({
  id: '/admin/content-seeds',
  path: '/admin/content-seeds',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBrandsRoute = AdminBrandsRouteImport.update({
  id: '/admin/brands',
  path: '/admin/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBenchmarksRoute = AdminBenchmarksRouteImport.update({
  id: '/admin/benchmarks',
  path: '/admin/benchmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAvatarsRoute = AdminAvatarsRouteImport.update({
  id: '/admin/avatars',
  path: '/admin/avatars',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAssetsRoute = AdminAssetsRouteImport.update({
  id: '/admin/assets',
  path: '/admin/assets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAssetJobsRoute = AdminAssetJobsRouteImport.update({
  id: '/admin/asset-jobs',
  path: '/admin/asset-jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdsPerformanceRoute = AdminAdsPerformanceRouteImport.update({
  id: '/admin/ads-performance',
  path: '/admin/ads-performance',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdLibraryRoute = AdminAdLibraryRouteImport.update({
  id: '/admin/ad-library',
  path: '/admin/ad-library',
  getParentRoute: () => rootRouteImport,
} as any)
const AdLibraryAdIdRoute = AdLibraryAdIdRouteImport.update({
  id: '/$adId',
  path: '/$adId',
  getParentRoute: () => AdLibraryRoute,
} as any)
const VideosVideoIdIndexRoute = VideosVideoIdIndexRouteImport.update({
  id: '/videos/$videoId/',
  path: '/videos/$videoId/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesSocialMonitorIndexRoute =
  PrototypesSocialMonitorIndexRouteImport.update({
    id: '/prototypes/social-monitor/',
    path: '/prototypes/social-monitor/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrototypesManwhaIndexRoute = PrototypesManwhaIndexRouteImport.update({
  id: '/prototypes/manwha/',
  path: '/prototypes/manwha/',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesImageEditorIndexRoute =
  PrototypesImageEditorIndexRouteImport.update({
    id: '/prototypes/image-editor/',
    path: '/prototypes/image-editor/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrototypesCarouselsIndexRoute =
  PrototypesCarouselsIndexRouteImport.update({
    id: '/prototypes/carousels/',
    path: '/prototypes/carousels/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminAdEngineIndexRoute = AdminAdEngineIndexRouteImport.update({
  id: '/admin/ad-engine/',
  path: '/admin/ad-engine/',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosVideoIdStoryboardRoute = VideosVideoIdStoryboardRouteImport.update({
  id: '/videos/$videoId/storyboard',
  path: '/videos/$videoId/storyboard',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosVideoIdEditorRoute = VideosVideoIdEditorRouteImport.update({
  id: '/videos/$videoId/editor',
  path: '/videos/$videoId/editor',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosVideoIdDebugRoute = VideosVideoIdDebugRouteImport.update({
  id: '/videos/$videoId/debug',
  path: '/videos/$videoId/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const PrototypesImageEditorImageEditIdRoute =
  PrototypesImageEditorImageEditIdRouteImport.update({
    id: '/prototypes/image-editor/$imageEditId',
    path: '/prototypes/image-editor/$imageEditId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrototypesCarouselsCarouselIdRoute =
  PrototypesCarouselsCarouselIdRouteImport.update({
    id: '/prototypes/carousels/$carouselId',
    path: '/prototypes/carousels/$carouselId',
    getParentRoute: () => rootRouteImport,
  } as any)
const MediaSpaceBoardBoardIdRoute = MediaSpaceBoardBoardIdRouteImport.update({
  id: '/board/$boardId',
  path: '/board/$boardId',
  getParentRoute: () => MediaSpaceRoute,
} as any)
const MediaSpaceAssetAssetIdRoute = MediaSpaceAssetAssetIdRouteImport.update({
  id: '/asset/$assetId',
  path: '/asset/$assetId',
  getParentRoute: () => MediaSpaceRoute,
} as any)
const CreateCaptionsVideoIdRoute = CreateCaptionsVideoIdRouteImport.update({
  id: '/$videoId',
  path: '/$videoId',
  getParentRoute: () => CreateCaptionsRoute,
} as any)
const AuthErrorSplatRoute = AuthErrorSplatRouteImport.update({
  id: '/auth/error/$',
  path: '/auth/error/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTraceVideoIdRoute = AdminTraceVideoIdRouteImport.update({
  id: '/admin/trace/$videoId',
  path: '/admin/trace/$videoId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTeamIdRoute = AdminTeamIdRouteImport.update({
  id: '/admin/team/$id',
  path: '/admin/team/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPipelinesExecutionIdRoute =
  AdminPipelinesExecutionIdRouteImport.update({
    id: '/$executionId',
    path: '/$executionId',
    getParentRoute: () => AdminPipelinesRoute,
  } as any)
const AdminAssetJobsIdRoute = AdminAssetJobsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminAssetJobsRoute,
} as any)
const AdminAdsPerformanceMetaCallbackRoute =
  AdminAdsPerformanceMetaCallbackRouteImport.update({
    id: '/meta-callback',
    path: '/meta-callback',
    getParentRoute: () => AdminAdsPerformanceRoute,
  } as any)
const AdminAdEngineReviewRoute = AdminAdEngineReviewRouteImport.update({
  id: '/admin/ad-engine/review',
  path: '/admin/ad-engine/review',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdEngineFormatsRoute = AdminAdEngineFormatsRouteImport.update({
  id: '/admin/ad-engine/formats',
  path: '/admin/ad-engine/formats',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAdEngineVideoIdRoute = AdminAdEngineVideoIdRouteImport.update({
  id: '/admin/ad-engine/$videoId',
  path: '/admin/ad-engine/$videoId',
  getParentRoute: () => rootRouteImport,
} as any)
const VideosVideoIdEditorIndexRoute =
  VideosVideoIdEditorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => VideosVideoIdEditorRoute,
  } as any)
const VideosVideoIdEditorRedditStoryRoute =
  VideosVideoIdEditorRedditStoryRouteImport.update({
    id: '/reddit-story',
    path: '/reddit-story',
    getParentRoute: () => VideosVideoIdEditorRoute,
  } as any)
const VideosVideoIdEditorGenzAvatarsRoute =
  VideosVideoIdEditorGenzAvatarsRouteImport.update({
    id: '/genz-avatars',
    path: '/genz-avatars',
    getParentRoute: () => VideosVideoIdEditorRoute,
  } as any)
const VideosVideoIdEditorFakeTextRoute =
  VideosVideoIdEditorFakeTextRouteImport.update({
    id: '/fake-text',
    path: '/fake-text',
    getParentRoute: () => VideosVideoIdEditorRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$modelSlug': typeof ModelSlugRoute
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/ad-library': typeof AdLibraryRouteWithChildren
  '/api-keys': typeof ApiKeysRoute
  '/asset-library': typeof AssetLibraryRouteWithChildren
  '/audio': typeof AudioRoute
  '/automated': typeof AutomatedRoute
  '/automated-create': typeof AutomatedCreateRoute
  '/b-roll': typeof BRollRoute
  '/billing': typeof BillingRoute
  '/brands': typeof BrandsRoute
  '/changelog': typeof ChangelogRoute
  '/creator': typeof CreatorRoute
  '/deletion-request': typeof DeletionRequestRoute
  '/developers': typeof DevelopersRoute
  '/docs': typeof DocsRoute
  '/home': typeof HomeRoute
  '/hooks': typeof HooksRoute
  '/how-it-works': typeof HowItWorksRoute
  '/media-space': typeof MediaSpaceRouteWithChildren
  '/pdf': typeof PdfRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/products': typeof ProductsRoute
  '/schedule': typeof ScheduleRoute
  '/sentry-break': typeof SentryBreakRoute
  '/signout': typeof SignoutRoute
  '/social-accounts': typeof SocialAccountsRoute
  '/storyboard-exploration': typeof StoryboardExplorationRoute
  '/terms': typeof TermsRoute
  '/ugc-ai-avatar': typeof UgcAiAvatarRoute
  '/usage': typeof UsageRoute
  '/voices': typeof VoicesRoute
  '/webhooks': typeof WebhooksRoute
  '/ad-library/$adId': typeof AdLibraryAdIdRoute
  '/admin/ad-library': typeof AdminAdLibraryRoute
  '/admin/ads-performance': typeof AdminAdsPerformanceRouteWithChildren
  '/admin/asset-jobs': typeof AdminAssetJobsRouteWithChildren
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/benchmarks': typeof AdminBenchmarksRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/content-seeds': typeof AdminContentSeedsRoute
  '/admin/editor-effects': typeof AdminEditorEffectsRoute
  '/admin/email': typeof AdminEmailRoute
  '/admin/evals': typeof AdminEvalsRoute
  '/admin/experiments': typeof AdminExperimentsRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/kev': typeof AdminKevRoute
  '/admin/mastra': typeof AdminMastraRoute
  '/admin/model-pricing': typeof AdminModelPricingRoute
  '/admin/model-registry': typeof AdminModelRegistryRoute
  '/admin/pipelines': typeof AdminPipelinesRouteWithChildren
  '/admin/presets': typeof AdminPresetsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/render-lab': typeof AdminRenderLabRoute
  '/admin/scheduledPosts': typeof AdminScheduledPostsRoute
  '/admin/series': typeof AdminSeriesRoute
  '/admin/signin': typeof AdminSigninRoute
  '/admin/static-ads': typeof AdminStaticAdsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/voices': typeof AdminVoicesRoute
  '/ads/static': typeof AdsStaticRoute
  '/asset-library/$assetId': typeof AssetLibraryAssetIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog/admin': typeof BlogAdminRoute
  '/create/ad-studio': typeof CreateAdStudioRoute
  '/create/audio': typeof CreateAudioRoute
  '/create/captions': typeof CreateCaptionsRouteWithChildren
  '/create/edit': typeof CreateEditRoute
  '/create/image': typeof CreateImageRoute
  '/create/ugc': typeof CreateUgcRoute
  '/create/ugc-avatars': typeof CreateUgcAvatarsRoute
  '/create/ugc-templates': typeof CreateUgcTemplatesRoute
  '/create/video': typeof CreateVideoRoute
  '/embed/edit': typeof EmbedEditRoute
  '/media-space/boards': typeof MediaSpaceBoardsRoute
  '/media-space/workflows': typeof MediaSpaceWorkflowsRoute
  '/series/$seriesId': typeof SeriesSeriesIdRoute
  '/team/invite': typeof TeamInviteRoute
  '/templates/ai-story': typeof TemplatesAiStoryRoute
  '/templates/fake-text': typeof TemplatesFakeTextRoute
  '/templates/genz-avatars': typeof TemplatesGenzAvatarsRoute
  '/templates/pov-story': typeof TemplatesPovStoryRoute
  '/templates/reddit-story': typeof TemplatesRedditStoryRoute
  '/tools/$id': typeof ToolsIdRoute
  '/tools/ad-scraper': typeof ToolsAdScraperRoute
  '/tools/ai-avatar': typeof ToolsAiAvatarRoute
  '/tools/ai-sound-effects': typeof ToolsAiSoundEffectsRoute
  '/tools/ai-voiceover': typeof ToolsAiVoiceoverRoute
  '/tools/asset-library': typeof ToolsAssetLibraryRoute
  '/tools/avatar-ad-generator': typeof ToolsAvatarAdGeneratorRoute
  '/tools/avatar-library': typeof ToolsAvatarLibraryRoute
  '/tools/background-remover': typeof ToolsBackgroundRemoverRoute
  '/tools/image-resizer': typeof ToolsImageResizerRoute
  '/tools/image-transformer': typeof ToolsImageTransformerRoute
  '/tools/image-upscaler': typeof ToolsImageUpscalerRoute
  '/tools/infinitetalk-demo': typeof ToolsInfinitetalkDemoRoute
  '/tools/prompt-hub': typeof ToolsPromptHubRoute
  '/tools/script-writer': typeof ToolsScriptWriterRoute
  '/tools/style-transfer': typeof ToolsStyleTransferRoute
  '/tools/veo3-generator': typeof ToolsVeo3GeneratorRoute
  '/tools/video-effects': typeof ToolsVideoEffectsRoute
  '/v/$linkId': typeof VLinkIdRoute
  '/viral/pricing': typeof ViralPricingRoute
  '/admin': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/blog': typeof BlogIndexRoute
  '/create': typeof CreateIndexRoute
  '/media-space/': typeof MediaSpaceIndexRoute
  '/success-stories': typeof SuccessStoriesIndexRoute
  '/team': typeof TeamIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/tutorial': typeof TutorialIndexRoute
  '/videos': typeof VideosIndexRoute
  '/viral': typeof ViralIndexRoute
  '/admin/ad-engine/$videoId': typeof AdminAdEngineVideoIdRoute
  '/admin/ad-engine/formats': typeof AdminAdEngineFormatsRoute
  '/admin/ad-engine/review': typeof AdminAdEngineReviewRoute
  '/admin/ads-performance/meta-callback': typeof AdminAdsPerformanceMetaCallbackRoute
  '/admin/asset-jobs/$id': typeof AdminAssetJobsIdRoute
  '/admin/pipelines/$executionId': typeof AdminPipelinesExecutionIdRoute
  '/admin/team/$id': typeof AdminTeamIdRoute
  '/admin/trace/$videoId': typeof AdminTraceVideoIdRoute
  '/auth/error/$': typeof AuthErrorSplatRoute
  '/create/captions/$videoId': typeof CreateCaptionsVideoIdRoute
  '/media-space/asset/$assetId': typeof MediaSpaceAssetAssetIdRoute
  '/media-space/board/$boardId': typeof MediaSpaceBoardBoardIdRoute
  '/prototypes/carousels/$carouselId': typeof PrototypesCarouselsCarouselIdRoute
  '/prototypes/image-editor/$imageEditId': typeof PrototypesImageEditorImageEditIdRoute
  '/videos/$videoId/debug': typeof VideosVideoIdDebugRoute
  '/videos/$videoId/editor': typeof VideosVideoIdEditorRouteWithChildren
  '/videos/$videoId/storyboard': typeof VideosVideoIdStoryboardRoute
  '/admin/ad-engine': typeof AdminAdEngineIndexRoute
  '/prototypes/carousels': typeof PrototypesCarouselsIndexRoute
  '/prototypes/image-editor': typeof PrototypesImageEditorIndexRoute
  '/prototypes/manwha': typeof PrototypesManwhaIndexRoute
  '/prototypes/social-monitor': typeof PrototypesSocialMonitorIndexRoute
  '/videos/$videoId': typeof VideosVideoIdIndexRoute
  '/videos/$videoId/editor/fake-text': typeof VideosVideoIdEditorFakeTextRoute
  '/videos/$videoId/editor/genz-avatars': typeof VideosVideoIdEditorGenzAvatarsRoute
  '/videos/$videoId/editor/reddit-story': typeof VideosVideoIdEditorRedditStoryRoute
  '/videos/$videoId/editor/': typeof VideosVideoIdEditorIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$modelSlug': typeof ModelSlugRoute
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/ad-library': typeof AdLibraryRouteWithChildren
  '/api-keys': typeof ApiKeysRoute
  '/asset-library': typeof AssetLibraryRouteWithChildren
  '/audio': typeof AudioRoute
  '/automated': typeof AutomatedRoute
  '/automated-create': typeof AutomatedCreateRoute
  '/b-roll': typeof BRollRoute
  '/billing': typeof BillingRoute
  '/brands': typeof BrandsRoute
  '/changelog': typeof ChangelogRoute
  '/creator': typeof CreatorRoute
  '/deletion-request': typeof DeletionRequestRoute
  '/developers': typeof DevelopersRoute
  '/docs': typeof DocsRoute
  '/home': typeof HomeRoute
  '/hooks': typeof HooksRoute
  '/how-it-works': typeof HowItWorksRoute
  '/pdf': typeof PdfRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/products': typeof ProductsRoute
  '/schedule': typeof ScheduleRoute
  '/sentry-break': typeof SentryBreakRoute
  '/signout': typeof SignoutRoute
  '/social-accounts': typeof SocialAccountsRoute
  '/storyboard-exploration': typeof StoryboardExplorationRoute
  '/terms': typeof TermsRoute
  '/ugc-ai-avatar': typeof UgcAiAvatarRoute
  '/usage': typeof UsageRoute
  '/voices': typeof VoicesRoute
  '/webhooks': typeof WebhooksRoute
  '/ad-library/$adId': typeof AdLibraryAdIdRoute
  '/admin/ad-library': typeof AdminAdLibraryRoute
  '/admin/ads-performance': typeof AdminAdsPerformanceRouteWithChildren
  '/admin/asset-jobs': typeof AdminAssetJobsRouteWithChildren
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/benchmarks': typeof AdminBenchmarksRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/content-seeds': typeof AdminContentSeedsRoute
  '/admin/editor-effects': typeof AdminEditorEffectsRoute
  '/admin/email': typeof AdminEmailRoute
  '/admin/evals': typeof AdminEvalsRoute
  '/admin/experiments': typeof AdminExperimentsRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/kev': typeof AdminKevRoute
  '/admin/mastra': typeof AdminMastraRoute
  '/admin/model-pricing': typeof AdminModelPricingRoute
  '/admin/model-registry': typeof AdminModelRegistryRoute
  '/admin/pipelines': typeof AdminPipelinesRouteWithChildren
  '/admin/presets': typeof AdminPresetsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/render-lab': typeof AdminRenderLabRoute
  '/admin/scheduledPosts': typeof AdminScheduledPostsRoute
  '/admin/series': typeof AdminSeriesRoute
  '/admin/signin': typeof AdminSigninRoute
  '/admin/static-ads': typeof AdminStaticAdsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/voices': typeof AdminVoicesRoute
  '/ads/static': typeof AdsStaticRoute
  '/asset-library/$assetId': typeof AssetLibraryAssetIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog/admin': typeof BlogAdminRoute
  '/create/ad-studio': typeof CreateAdStudioRoute
  '/create/audio': typeof CreateAudioRoute
  '/create/captions': typeof CreateCaptionsRouteWithChildren
  '/create/edit': typeof CreateEditRoute
  '/create/image': typeof CreateImageRoute
  '/create/ugc': typeof CreateUgcRoute
  '/create/ugc-avatars': typeof CreateUgcAvatarsRoute
  '/create/ugc-templates': typeof CreateUgcTemplatesRoute
  '/create/video': typeof CreateVideoRoute
  '/embed/edit': typeof EmbedEditRoute
  '/media-space/boards': typeof MediaSpaceBoardsRoute
  '/media-space/workflows': typeof MediaSpaceWorkflowsRoute
  '/series/$seriesId': typeof SeriesSeriesIdRoute
  '/team/invite': typeof TeamInviteRoute
  '/templates/ai-story': typeof TemplatesAiStoryRoute
  '/templates/fake-text': typeof TemplatesFakeTextRoute
  '/templates/genz-avatars': typeof TemplatesGenzAvatarsRoute
  '/templates/pov-story': typeof TemplatesPovStoryRoute
  '/templates/reddit-story': typeof TemplatesRedditStoryRoute
  '/tools/$id': typeof ToolsIdRoute
  '/tools/ad-scraper': typeof ToolsAdScraperRoute
  '/tools/ai-avatar': typeof ToolsAiAvatarRoute
  '/tools/ai-sound-effects': typeof ToolsAiSoundEffectsRoute
  '/tools/ai-voiceover': typeof ToolsAiVoiceoverRoute
  '/tools/asset-library': typeof ToolsAssetLibraryRoute
  '/tools/avatar-ad-generator': typeof ToolsAvatarAdGeneratorRoute
  '/tools/avatar-library': typeof ToolsAvatarLibraryRoute
  '/tools/background-remover': typeof ToolsBackgroundRemoverRoute
  '/tools/image-resizer': typeof ToolsImageResizerRoute
  '/tools/image-transformer': typeof ToolsImageTransformerRoute
  '/tools/image-upscaler': typeof ToolsImageUpscalerRoute
  '/tools/infinitetalk-demo': typeof ToolsInfinitetalkDemoRoute
  '/tools/prompt-hub': typeof ToolsPromptHubRoute
  '/tools/script-writer': typeof ToolsScriptWriterRoute
  '/tools/style-transfer': typeof ToolsStyleTransferRoute
  '/tools/veo3-generator': typeof ToolsVeo3GeneratorRoute
  '/tools/video-effects': typeof ToolsVideoEffectsRoute
  '/v/$linkId': typeof VLinkIdRoute
  '/viral/pricing': typeof ViralPricingRoute
  '/admin': typeof AdminIndexRoute
  '/auth': typeof AuthIndexRoute
  '/blog': typeof BlogIndexRoute
  '/create': typeof CreateIndexRoute
  '/media-space': typeof MediaSpaceIndexRoute
  '/success-stories': typeof SuccessStoriesIndexRoute
  '/team': typeof TeamIndexRoute
  '/templates': typeof TemplatesIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/tutorial': typeof TutorialIndexRoute
  '/videos': typeof VideosIndexRoute
  '/viral': typeof ViralIndexRoute
  '/admin/ad-engine/$videoId': typeof AdminAdEngineVideoIdRoute
  '/admin/ad-engine/formats': typeof AdminAdEngineFormatsRoute
  '/admin/ad-engine/review': typeof AdminAdEngineReviewRoute
  '/admin/ads-performance/meta-callback': typeof AdminAdsPerformanceMetaCallbackRoute
  '/admin/asset-jobs/$id': typeof AdminAssetJobsIdRoute
  '/admin/pipelines/$executionId': typeof AdminPipelinesExecutionIdRoute
  '/admin/team/$id': typeof AdminTeamIdRoute
  '/admin/trace/$videoId': typeof AdminTraceVideoIdRoute
  '/auth/error/$': typeof AuthErrorSplatRoute
  '/create/captions/$videoId': typeof CreateCaptionsVideoIdRoute
  '/media-space/asset/$assetId': typeof MediaSpaceAssetAssetIdRoute
  '/media-space/board/$boardId': typeof MediaSpaceBoardBoardIdRoute
  '/prototypes/carousels/$carouselId': typeof PrototypesCarouselsCarouselIdRoute
  '/prototypes/image-editor/$imageEditId': typeof PrototypesImageEditorImageEditIdRoute
  '/videos/$videoId/debug': typeof VideosVideoIdDebugRoute
  '/videos/$videoId/storyboard': typeof VideosVideoIdStoryboardRoute
  '/admin/ad-engine': typeof AdminAdEngineIndexRoute
  '/prototypes/carousels': typeof PrototypesCarouselsIndexRoute
  '/prototypes/image-editor': typeof PrototypesImageEditorIndexRoute
  '/prototypes/manwha': typeof PrototypesManwhaIndexRoute
  '/prototypes/social-monitor': typeof PrototypesSocialMonitorIndexRoute
  '/videos/$videoId': typeof VideosVideoIdIndexRoute
  '/videos/$videoId/editor/fake-text': typeof VideosVideoIdEditorFakeTextRoute
  '/videos/$videoId/editor/genz-avatars': typeof VideosVideoIdEditorGenzAvatarsRoute
  '/videos/$videoId/editor/reddit-story': typeof VideosVideoIdEditorRedditStoryRoute
  '/videos/$videoId/editor': typeof VideosVideoIdEditorIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$modelSlug': typeof ModelSlugRoute
  '/404': typeof R404Route
  '/account': typeof AccountRoute
  '/ad-library': typeof AdLibraryRouteWithChildren
  '/api-keys': typeof ApiKeysRoute
  '/asset-library': typeof AssetLibraryRouteWithChildren
  '/audio': typeof AudioRoute
  '/automated': typeof AutomatedRoute
  '/automated-create': typeof AutomatedCreateRoute
  '/b-roll': typeof BRollRoute
  '/billing': typeof BillingRoute
  '/brands': typeof BrandsRoute
  '/changelog': typeof ChangelogRoute
  '/creator': typeof CreatorRoute
  '/deletion-request': typeof DeletionRequestRoute
  '/developers': typeof DevelopersRoute
  '/docs': typeof DocsRoute
  '/home': typeof HomeRoute
  '/hooks': typeof HooksRoute
  '/how-it-works': typeof HowItWorksRoute
  '/media-space': typeof MediaSpaceRouteWithChildren
  '/pdf': typeof PdfRoute
  '/pricing': typeof PricingRoute
  '/privacy': typeof PrivacyRoute
  '/products': typeof ProductsRoute
  '/schedule': typeof ScheduleRoute
  '/sentry-break': typeof SentryBreakRoute
  '/signout': typeof SignoutRoute
  '/social-accounts': typeof SocialAccountsRoute
  '/storyboard-exploration': typeof StoryboardExplorationRoute
  '/terms': typeof TermsRoute
  '/ugc-ai-avatar': typeof UgcAiAvatarRoute
  '/usage': typeof UsageRoute
  '/voices': typeof VoicesRoute
  '/webhooks': typeof WebhooksRoute
  '/ad-library/$adId': typeof AdLibraryAdIdRoute
  '/admin/ad-library': typeof AdminAdLibraryRoute
  '/admin/ads-performance': typeof AdminAdsPerformanceRouteWithChildren
  '/admin/asset-jobs': typeof AdminAssetJobsRouteWithChildren
  '/admin/assets': typeof AdminAssetsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/benchmarks': typeof AdminBenchmarksRoute
  '/admin/brands': typeof AdminBrandsRoute
  '/admin/content-seeds': typeof AdminContentSeedsRoute
  '/admin/editor-effects': typeof AdminEditorEffectsRoute
  '/admin/email': typeof AdminEmailRoute
  '/admin/evals': typeof AdminEvalsRoute
  '/admin/experiments': typeof AdminExperimentsRoute
  '/admin/feedback': typeof AdminFeedbackRoute
  '/admin/kev': typeof AdminKevRoute
  '/admin/mastra': typeof AdminMastraRoute
  '/admin/model-pricing': typeof AdminModelPricingRoute
  '/admin/model-registry': typeof AdminModelRegistryRoute
  '/admin/pipelines': typeof AdminPipelinesRouteWithChildren
  '/admin/presets': typeof AdminPresetsRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/render-lab': typeof AdminRenderLabRoute
  '/admin/scheduledPosts': typeof AdminScheduledPostsRoute
  '/admin/series': typeof AdminSeriesRoute
  '/admin/signin': typeof AdminSigninRoute
  '/admin/static-ads': typeof AdminStaticAdsRoute
  '/admin/teams': typeof AdminTeamsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/voices': typeof AdminVoicesRoute
  '/ads/static': typeof AdsStaticRoute
  '/asset-library/$assetId': typeof AssetLibraryAssetIdRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signout': typeof AuthSignoutRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/blog/admin': typeof BlogAdminRoute
  '/create/ad-studio': typeof CreateAdStudioRoute
  '/create/audio': typeof CreateAudioRoute
  '/create/captions': typeof CreateCaptionsRouteWithChildren
  '/create/edit': typeof CreateEditRoute
  '/create/image': typeof CreateImageRoute
  '/create/ugc': typeof CreateUgcRoute
  '/create/ugc-avatars': typeof CreateUgcAvatarsRoute
  '/create/ugc-templates': typeof CreateUgcTemplatesRoute
  '/create/video': typeof CreateVideoRoute
  '/embed/edit': typeof EmbedEditRoute
  '/media-space/boards': typeof MediaSpaceBoardsRoute
  '/media-space/workflows': typeof MediaSpaceWorkflowsRoute
  '/series/$seriesId': typeof SeriesSeriesIdRoute
  '/team/invite': typeof TeamInviteRoute
  '/templates/ai-story': typeof TemplatesAiStoryRoute
  '/templates/fake-text': typeof TemplatesFakeTextRoute
  '/templates/genz-avatars': typeof TemplatesGenzAvatarsRoute
  '/templates/pov-story': typeof TemplatesPovStoryRoute
  '/templates/reddit-story': typeof TemplatesRedditStoryRoute
  '/tools/$id': typeof ToolsIdRoute
  '/tools/ad-scraper': typeof ToolsAdScraperRoute
  '/tools/ai-avatar': typeof ToolsAiAvatarRoute
  '/tools/ai-sound-effects': typeof ToolsAiSoundEffectsRoute
  '/tools/ai-voiceover': typeof ToolsAiVoiceoverRoute
  '/tools/asset-library': typeof ToolsAssetLibraryRoute
  '/tools/avatar-ad-generator': typeof ToolsAvatarAdGeneratorRoute
  '/tools/avatar-library': typeof ToolsAvatarLibraryRoute
  '/tools/background-remover': typeof ToolsBackgroundRemoverRoute
  '/tools/image-resizer': typeof ToolsImageResizerRoute
  '/tools/image-transformer': typeof ToolsImageTransformerRoute
  '/tools/image-upscaler': typeof ToolsImageUpscalerRoute
  '/tools/infinitetalk-demo': typeof ToolsInfinitetalkDemoRoute
  '/tools/prompt-hub': typeof ToolsPromptHubRoute
  '/tools/script-writer': typeof ToolsScriptWriterRoute
  '/tools/style-transfer': typeof ToolsStyleTransferRoute
  '/tools/veo3-generator': typeof ToolsVeo3GeneratorRoute
  '/tools/video-effects': typeof ToolsVideoEffectsRoute
  '/v/$linkId': typeof VLinkIdRoute
  '/viral/pricing': typeof ViralPricingRoute
  '/admin/': typeof AdminIndexRoute
  '/auth/': typeof AuthIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/create/': typeof CreateIndexRoute
  '/media-space/': typeof MediaSpaceIndexRoute
  '/success-stories/': typeof SuccessStoriesIndexRoute
  '/team/': typeof TeamIndexRoute
  '/templates/': typeof TemplatesIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/tutorial/': typeof TutorialIndexRoute
  '/videos/': typeof VideosIndexRoute
  '/viral/': typeof ViralIndexRoute
  '/admin/ad-engine/$videoId': typeof AdminAdEngineVideoIdRoute
  '/admin/ad-engine/formats': typeof AdminAdEngineFormatsRoute
  '/admin/ad-engine/review': typeof AdminAdEngineReviewRoute
  '/admin/ads-performance/meta-callback': typeof AdminAdsPerformanceMetaCallbackRoute
  '/admin/asset-jobs/$id': typeof AdminAssetJobsIdRoute
  '/admin/pipelines/$executionId': typeof AdminPipelinesExecutionIdRoute
  '/admin/team/$id': typeof AdminTeamIdRoute
  '/admin/trace/$videoId': typeof AdminTraceVideoIdRoute
  '/auth/error/$': typeof AuthErrorSplatRoute
  '/create/captions/$videoId': typeof CreateCaptionsVideoIdRoute
  '/media-space/asset/$assetId': typeof MediaSpaceAssetAssetIdRoute
  '/media-space/board/$boardId': typeof MediaSpaceBoardBoardIdRoute
  '/prototypes/carousels/$carouselId': typeof PrototypesCarouselsCarouselIdRoute
  '/prototypes/image-editor/$imageEditId': typeof PrototypesImageEditorImageEditIdRoute
  '/videos/$videoId/debug': typeof VideosVideoIdDebugRoute
  '/videos/$videoId/editor': typeof VideosVideoIdEditorRouteWithChildren
  '/videos/$videoId/storyboard': typeof VideosVideoIdStoryboardRoute
  '/admin/ad-engine/': typeof AdminAdEngineIndexRoute
  '/prototypes/carousels/': typeof PrototypesCarouselsIndexRoute
  '/prototypes/image-editor/': typeof PrototypesImageEditorIndexRoute
  '/prototypes/manwha/': typeof PrototypesManwhaIndexRoute
  '/prototypes/social-monitor/': typeof PrototypesSocialMonitorIndexRoute
  '/videos/$videoId/': typeof VideosVideoIdIndexRoute
  '/videos/$videoId/editor/fake-text': typeof VideosVideoIdEditorFakeTextRoute
  '/videos/$videoId/editor/genz-avatars': typeof VideosVideoIdEditorGenzAvatarsRoute
  '/videos/$videoId/editor/reddit-story': typeof VideosVideoIdEditorRedditStoryRoute
  '/videos/$videoId/editor/': typeof VideosVideoIdEditorIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$modelSlug'
    | '/404'
    | '/account'
    | '/ad-library'
    | '/api-keys'
    | '/asset-library'
    | '/audio'
    | '/automated'
    | '/automated-create'
    | '/b-roll'
    | '/billing'
    | '/brands'
    | '/changelog'
    | '/creator'
    | '/deletion-request'
    | '/developers'
    | '/docs'
    | '/home'
    | '/hooks'
    | '/how-it-works'
    | '/media-space'
    | '/pdf'
    | '/pricing'
    | '/privacy'
    | '/products'
    | '/schedule'
    | '/sentry-break'
    | '/signout'
    | '/social-accounts'
    | '/storyboard-exploration'
    | '/terms'
    | '/ugc-ai-avatar'
    | '/usage'
    | '/voices'
    | '/webhooks'
    | '/ad-library/$adId'
    | '/admin/ad-library'
    | '/admin/ads-performance'
    | '/admin/asset-jobs'
    | '/admin/assets'
    | '/admin/audit'
    | '/admin/avatars'
    | '/admin/benchmarks'
    | '/admin/brands'
    | '/admin/content-seeds'
    | '/admin/editor-effects'
    | '/admin/email'
    | '/admin/evals'
    | '/admin/experiments'
    | '/admin/feedback'
    | '/admin/kev'
    | '/admin/mastra'
    | '/admin/model-pricing'
    | '/admin/model-registry'
    | '/admin/pipelines'
    | '/admin/presets'
    | '/admin/products'
    | '/admin/render-lab'
    | '/admin/scheduledPosts'
    | '/admin/series'
    | '/admin/signin'
    | '/admin/static-ads'
    | '/admin/teams'
    | '/admin/tools'
    | '/admin/users'
    | '/admin/videos'
    | '/admin/voices'
    | '/ads/static'
    | '/asset-library/$assetId'
    | '/auth/callback'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/verify'
    | '/blog/$slug'
    | '/blog/admin'
    | '/create/ad-studio'
    | '/create/audio'
    | '/create/captions'
    | '/create/edit'
    | '/create/image'
    | '/create/ugc'
    | '/create/ugc-avatars'
    | '/create/ugc-templates'
    | '/create/video'
    | '/embed/edit'
    | '/media-space/boards'
    | '/media-space/workflows'
    | '/series/$seriesId'
    | '/team/invite'
    | '/templates/ai-story'
    | '/templates/fake-text'
    | '/templates/genz-avatars'
    | '/templates/pov-story'
    | '/templates/reddit-story'
    | '/tools/$id'
    | '/tools/ad-scraper'
    | '/tools/ai-avatar'
    | '/tools/ai-sound-effects'
    | '/tools/ai-voiceover'
    | '/tools/asset-library'
    | '/tools/avatar-ad-generator'
    | '/tools/avatar-library'
    | '/tools/background-remover'
    | '/tools/image-resizer'
    | '/tools/image-transformer'
    | '/tools/image-upscaler'
    | '/tools/infinitetalk-demo'
    | '/tools/prompt-hub'
    | '/tools/script-writer'
    | '/tools/style-transfer'
    | '/tools/veo3-generator'
    | '/tools/video-effects'
    | '/v/$linkId'
    | '/viral/pricing'
    | '/admin'
    | '/auth'
    | '/blog'
    | '/create'
    | '/media-space/'
    | '/success-stories'
    | '/team'
    | '/templates'
    | '/tools'
    | '/tutorial'
    | '/videos'
    | '/viral'
    | '/admin/ad-engine/$videoId'
    | '/admin/ad-engine/formats'
    | '/admin/ad-engine/review'
    | '/admin/ads-performance/meta-callback'
    | '/admin/asset-jobs/$id'
    | '/admin/pipelines/$executionId'
    | '/admin/team/$id'
    | '/admin/trace/$videoId'
    | '/auth/error/$'
    | '/create/captions/$videoId'
    | '/media-space/asset/$assetId'
    | '/media-space/board/$boardId'
    | '/prototypes/carousels/$carouselId'
    | '/prototypes/image-editor/$imageEditId'
    | '/videos/$videoId/debug'
    | '/videos/$videoId/editor'
    | '/videos/$videoId/storyboard'
    | '/admin/ad-engine'
    | '/prototypes/carousels'
    | '/prototypes/image-editor'
    | '/prototypes/manwha'
    | '/prototypes/social-monitor'
    | '/videos/$videoId'
    | '/videos/$videoId/editor/fake-text'
    | '/videos/$videoId/editor/genz-avatars'
    | '/videos/$videoId/editor/reddit-story'
    | '/videos/$videoId/editor/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$modelSlug'
    | '/404'
    | '/account'
    | '/ad-library'
    | '/api-keys'
    | '/asset-library'
    | '/audio'
    | '/automated'
    | '/automated-create'
    | '/b-roll'
    | '/billing'
    | '/brands'
    | '/changelog'
    | '/creator'
    | '/deletion-request'
    | '/developers'
    | '/docs'
    | '/home'
    | '/hooks'
    | '/how-it-works'
    | '/pdf'
    | '/pricing'
    | '/privacy'
    | '/products'
    | '/schedule'
    | '/sentry-break'
    | '/signout'
    | '/social-accounts'
    | '/storyboard-exploration'
    | '/terms'
    | '/ugc-ai-avatar'
    | '/usage'
    | '/voices'
    | '/webhooks'
    | '/ad-library/$adId'
    | '/admin/ad-library'
    | '/admin/ads-performance'
    | '/admin/asset-jobs'
    | '/admin/assets'
    | '/admin/audit'
    | '/admin/avatars'
    | '/admin/benchmarks'
    | '/admin/brands'
    | '/admin/content-seeds'
    | '/admin/editor-effects'
    | '/admin/email'
    | '/admin/evals'
    | '/admin/experiments'
    | '/admin/feedback'
    | '/admin/kev'
    | '/admin/mastra'
    | '/admin/model-pricing'
    | '/admin/model-registry'
    | '/admin/pipelines'
    | '/admin/presets'
    | '/admin/products'
    | '/admin/render-lab'
    | '/admin/scheduledPosts'
    | '/admin/series'
    | '/admin/signin'
    | '/admin/static-ads'
    | '/admin/teams'
    | '/admin/tools'
    | '/admin/users'
    | '/admin/videos'
    | '/admin/voices'
    | '/ads/static'
    | '/asset-library/$assetId'
    | '/auth/callback'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/verify'
    | '/blog/$slug'
    | '/blog/admin'
    | '/create/ad-studio'
    | '/create/audio'
    | '/create/captions'
    | '/create/edit'
    | '/create/image'
    | '/create/ugc'
    | '/create/ugc-avatars'
    | '/create/ugc-templates'
    | '/create/video'
    | '/embed/edit'
    | '/media-space/boards'
    | '/media-space/workflows'
    | '/series/$seriesId'
    | '/team/invite'
    | '/templates/ai-story'
    | '/templates/fake-text'
    | '/templates/genz-avatars'
    | '/templates/pov-story'
    | '/templates/reddit-story'
    | '/tools/$id'
    | '/tools/ad-scraper'
    | '/tools/ai-avatar'
    | '/tools/ai-sound-effects'
    | '/tools/ai-voiceover'
    | '/tools/asset-library'
    | '/tools/avatar-ad-generator'
    | '/tools/avatar-library'
    | '/tools/background-remover'
    | '/tools/image-resizer'
    | '/tools/image-transformer'
    | '/tools/image-upscaler'
    | '/tools/infinitetalk-demo'
    | '/tools/prompt-hub'
    | '/tools/script-writer'
    | '/tools/style-transfer'
    | '/tools/veo3-generator'
    | '/tools/video-effects'
    | '/v/$linkId'
    | '/viral/pricing'
    | '/admin'
    | '/auth'
    | '/blog'
    | '/create'
    | '/media-space'
    | '/success-stories'
    | '/team'
    | '/templates'
    | '/tools'
    | '/tutorial'
    | '/videos'
    | '/viral'
    | '/admin/ad-engine/$videoId'
    | '/admin/ad-engine/formats'
    | '/admin/ad-engine/review'
    | '/admin/ads-performance/meta-callback'
    | '/admin/asset-jobs/$id'
    | '/admin/pipelines/$executionId'
    | '/admin/team/$id'
    | '/admin/trace/$videoId'
    | '/auth/error/$'
    | '/create/captions/$videoId'
    | '/media-space/asset/$assetId'
    | '/media-space/board/$boardId'
    | '/prototypes/carousels/$carouselId'
    | '/prototypes/image-editor/$imageEditId'
    | '/videos/$videoId/debug'
    | '/videos/$videoId/storyboard'
    | '/admin/ad-engine'
    | '/prototypes/carousels'
    | '/prototypes/image-editor'
    | '/prototypes/manwha'
    | '/prototypes/social-monitor'
    | '/videos/$videoId'
    | '/videos/$videoId/editor/fake-text'
    | '/videos/$videoId/editor/genz-avatars'
    | '/videos/$videoId/editor/reddit-story'
    | '/videos/$videoId/editor'
  id:
    | '__root__'
    | '/'
    | '/$modelSlug'
    | '/404'
    | '/account'
    | '/ad-library'
    | '/api-keys'
    | '/asset-library'
    | '/audio'
    | '/automated'
    | '/automated-create'
    | '/b-roll'
    | '/billing'
    | '/brands'
    | '/changelog'
    | '/creator'
    | '/deletion-request'
    | '/developers'
    | '/docs'
    | '/home'
    | '/hooks'
    | '/how-it-works'
    | '/media-space'
    | '/pdf'
    | '/pricing'
    | '/privacy'
    | '/products'
    | '/schedule'
    | '/sentry-break'
    | '/signout'
    | '/social-accounts'
    | '/storyboard-exploration'
    | '/terms'
    | '/ugc-ai-avatar'
    | '/usage'
    | '/voices'
    | '/webhooks'
    | '/ad-library/$adId'
    | '/admin/ad-library'
    | '/admin/ads-performance'
    | '/admin/asset-jobs'
    | '/admin/assets'
    | '/admin/audit'
    | '/admin/avatars'
    | '/admin/benchmarks'
    | '/admin/brands'
    | '/admin/content-seeds'
    | '/admin/editor-effects'
    | '/admin/email'
    | '/admin/evals'
    | '/admin/experiments'
    | '/admin/feedback'
    | '/admin/kev'
    | '/admin/mastra'
    | '/admin/model-pricing'
    | '/admin/model-registry'
    | '/admin/pipelines'
    | '/admin/presets'
    | '/admin/products'
    | '/admin/render-lab'
    | '/admin/scheduledPosts'
    | '/admin/series'
    | '/admin/signin'
    | '/admin/static-ads'
    | '/admin/teams'
    | '/admin/tools'
    | '/admin/users'
    | '/admin/videos'
    | '/admin/voices'
    | '/ads/static'
    | '/asset-library/$assetId'
    | '/auth/callback'
    | '/auth/signin'
    | '/auth/signout'
    | '/auth/verify'
    | '/blog/$slug'
    | '/blog/admin'
    | '/create/ad-studio'
    | '/create/audio'
    | '/create/captions'
    | '/create/edit'
    | '/create/image'
    | '/create/ugc'
    | '/create/ugc-avatars'
    | '/create/ugc-templates'
    | '/create/video'
    | '/embed/edit'
    | '/media-space/boards'
    | '/media-space/workflows'
    | '/series/$seriesId'
    | '/team/invite'
    | '/templates/ai-story'
    | '/templates/fake-text'
    | '/templates/genz-avatars'
    | '/templates/pov-story'
    | '/templates/reddit-story'
    | '/tools/$id'
    | '/tools/ad-scraper'
    | '/tools/ai-avatar'
    | '/tools/ai-sound-effects'
    | '/tools/ai-voiceover'
    | '/tools/asset-library'
    | '/tools/avatar-ad-generator'
    | '/tools/avatar-library'
    | '/tools/background-remover'
    | '/tools/image-resizer'
    | '/tools/image-transformer'
    | '/tools/image-upscaler'
    | '/tools/infinitetalk-demo'
    | '/tools/prompt-hub'
    | '/tools/script-writer'
    | '/tools/style-transfer'
    | '/tools/veo3-generator'
    | '/tools/video-effects'
    | '/v/$linkId'
    | '/viral/pricing'
    | '/admin/'
    | '/auth/'
    | '/blog/'
    | '/create/'
    | '/media-space/'
    | '/success-stories/'
    | '/team/'
    | '/templates/'
    | '/tools/'
    | '/tutorial/'
    | '/videos/'
    | '/viral/'
    | '/admin/ad-engine/$videoId'
    | '/admin/ad-engine/formats'
    | '/admin/ad-engine/review'
    | '/admin/ads-performance/meta-callback'
    | '/admin/asset-jobs/$id'
    | '/admin/pipelines/$executionId'
    | '/admin/team/$id'
    | '/admin/trace/$videoId'
    | '/auth/error/$'
    | '/create/captions/$videoId'
    | '/media-space/asset/$assetId'
    | '/media-space/board/$boardId'
    | '/prototypes/carousels/$carouselId'
    | '/prototypes/image-editor/$imageEditId'
    | '/videos/$videoId/debug'
    | '/videos/$videoId/editor'
    | '/videos/$videoId/storyboard'
    | '/admin/ad-engine/'
    | '/prototypes/carousels/'
    | '/prototypes/image-editor/'
    | '/prototypes/manwha/'
    | '/prototypes/social-monitor/'
    | '/videos/$videoId/'
    | '/videos/$videoId/editor/fake-text'
    | '/videos/$videoId/editor/genz-avatars'
    | '/videos/$videoId/editor/reddit-story'
    | '/videos/$videoId/editor/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ModelSlugRoute: typeof ModelSlugRoute
  R404Route: typeof R404Route
  AccountRoute: typeof AccountRoute
  AdLibraryRoute: typeof AdLibraryRouteWithChildren
  ApiKeysRoute: typeof ApiKeysRoute
  AssetLibraryRoute: typeof AssetLibraryRouteWithChildren
  AudioRoute: typeof AudioRoute
  AutomatedRoute: typeof AutomatedRoute
  AutomatedCreateRoute: typeof AutomatedCreateRoute
  BRollRoute: typeof BRollRoute
  BillingRoute: typeof BillingRoute
  BrandsRoute: typeof BrandsRoute
  ChangelogRoute: typeof ChangelogRoute
  CreatorRoute: typeof CreatorRoute
  DeletionRequestRoute: typeof DeletionRequestRoute
  DevelopersRoute: typeof DevelopersRoute
  DocsRoute: typeof DocsRoute
  HomeRoute: typeof HomeRoute
  HooksRoute: typeof HooksRoute
  HowItWorksRoute: typeof HowItWorksRoute
  MediaSpaceRoute: typeof MediaSpaceRouteWithChildren
  PdfRoute: typeof PdfRoute
  PricingRoute: typeof PricingRoute
  PrivacyRoute: typeof PrivacyRoute
  ProductsRoute: typeof ProductsRoute
  ScheduleRoute: typeof ScheduleRoute
  SentryBreakRoute: typeof SentryBreakRoute
  SignoutRoute: typeof SignoutRoute
  SocialAccountsRoute: typeof SocialAccountsRoute
  StoryboardExplorationRoute: typeof StoryboardExplorationRoute
  TermsRoute: typeof TermsRoute
  UgcAiAvatarRoute: typeof UgcAiAvatarRoute
  UsageRoute: typeof UsageRoute
  VoicesRoute: typeof VoicesRoute
  WebhooksRoute: typeof WebhooksRoute
  AdminAdLibraryRoute: typeof AdminAdLibraryRoute
  AdminAdsPerformanceRoute: typeof AdminAdsPerformanceRouteWithChildren
  AdminAssetJobsRoute: typeof AdminAssetJobsRouteWithChildren
  AdminAssetsRoute: typeof AdminAssetsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminAvatarsRoute: typeof AdminAvatarsRoute
  AdminBenchmarksRoute: typeof AdminBenchmarksRoute
  AdminBrandsRoute: typeof AdminBrandsRoute
  AdminContentSeedsRoute: typeof AdminContentSeedsRoute
  AdminEditorEffectsRoute: typeof AdminEditorEffectsRoute
  AdminEmailRoute: typeof AdminEmailRoute
  AdminEvalsRoute: typeof AdminEvalsRoute
  AdminExperimentsRoute: typeof AdminExperimentsRoute
  AdminFeedbackRoute: typeof AdminFeedbackRoute
  AdminKevRoute: typeof AdminKevRoute
  AdminMastraRoute: typeof AdminMastraRoute
  AdminModelPricingRoute: typeof AdminModelPricingRoute
  AdminModelRegistryRoute: typeof AdminModelRegistryRoute
  AdminPipelinesRoute: typeof AdminPipelinesRouteWithChildren
  AdminPresetsRoute: typeof AdminPresetsRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminRenderLabRoute: typeof AdminRenderLabRoute
  AdminScheduledPostsRoute: typeof AdminScheduledPostsRoute
  AdminSeriesRoute: typeof AdminSeriesRoute
  AdminSigninRoute: typeof AdminSigninRoute
  AdminStaticAdsRoute: typeof AdminStaticAdsRoute
  AdminTeamsRoute: typeof AdminTeamsRoute
  AdminToolsRoute: typeof AdminToolsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminVideosRoute: typeof AdminVideosRoute
  AdminVoicesRoute: typeof AdminVoicesRoute
  AdsStaticRoute: typeof AdsStaticRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignoutRoute: typeof AuthSignoutRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  BlogSlugRoute: typeof BlogSlugRoute
  BlogAdminRoute: typeof BlogAdminRoute
  CreateAdStudioRoute: typeof CreateAdStudioRoute
  CreateAudioRoute: typeof CreateAudioRoute
  CreateCaptionsRoute: typeof CreateCaptionsRouteWithChildren
  CreateEditRoute: typeof CreateEditRoute
  CreateImageRoute: typeof CreateImageRoute
  CreateUgcRoute: typeof CreateUgcRoute
  CreateUgcAvatarsRoute: typeof CreateUgcAvatarsRoute
  CreateUgcTemplatesRoute: typeof CreateUgcTemplatesRoute
  CreateVideoRoute: typeof CreateVideoRoute
  EmbedEditRoute: typeof EmbedEditRoute
  SeriesSeriesIdRoute: typeof SeriesSeriesIdRoute
  TeamInviteRoute: typeof TeamInviteRoute
  TemplatesAiStoryRoute: typeof TemplatesAiStoryRoute
  TemplatesFakeTextRoute: typeof TemplatesFakeTextRoute
  TemplatesGenzAvatarsRoute: typeof TemplatesGenzAvatarsRoute
  TemplatesPovStoryRoute: typeof TemplatesPovStoryRoute
  TemplatesRedditStoryRoute: typeof TemplatesRedditStoryRoute
  ToolsIdRoute: typeof ToolsIdRoute
  ToolsAdScraperRoute: typeof ToolsAdScraperRoute
  ToolsAiAvatarRoute: typeof ToolsAiAvatarRoute
  ToolsAiSoundEffectsRoute: typeof ToolsAiSoundEffectsRoute
  ToolsAiVoiceoverRoute: typeof ToolsAiVoiceoverRoute
  ToolsAssetLibraryRoute: typeof ToolsAssetLibraryRoute
  ToolsAvatarAdGeneratorRoute: typeof ToolsAvatarAdGeneratorRoute
  ToolsAvatarLibraryRoute: typeof ToolsAvatarLibraryRoute
  ToolsBackgroundRemoverRoute: typeof ToolsBackgroundRemoverRoute
  ToolsImageResizerRoute: typeof ToolsImageResizerRoute
  ToolsImageTransformerRoute: typeof ToolsImageTransformerRoute
  ToolsImageUpscalerRoute: typeof ToolsImageUpscalerRoute
  ToolsInfinitetalkDemoRoute: typeof ToolsInfinitetalkDemoRoute
  ToolsPromptHubRoute: typeof ToolsPromptHubRoute
  ToolsScriptWriterRoute: typeof ToolsScriptWriterRoute
  ToolsStyleTransferRoute: typeof ToolsStyleTransferRoute
  ToolsVeo3GeneratorRoute: typeof ToolsVeo3GeneratorRoute
  ToolsVideoEffectsRoute: typeof ToolsVideoEffectsRoute
  VLinkIdRoute: typeof VLinkIdRoute
  ViralPricingRoute: typeof ViralPricingRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AuthIndexRoute: typeof AuthIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  CreateIndexRoute: typeof CreateIndexRoute
  SuccessStoriesIndexRoute: typeof SuccessStoriesIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
  TemplatesIndexRoute: typeof TemplatesIndexRoute
  ToolsIndexRoute: typeof ToolsIndexRoute
  TutorialIndexRoute: typeof TutorialIndexRoute
  VideosIndexRoute: typeof VideosIndexRoute
  ViralIndexRoute: typeof ViralIndexRoute
  AdminAdEngineVideoIdRoute: typeof AdminAdEngineVideoIdRoute
  AdminAdEngineFormatsRoute: typeof AdminAdEngineFormatsRoute
  AdminAdEngineReviewRoute: typeof AdminAdEngineReviewRoute
  AdminTeamIdRoute: typeof AdminTeamIdRoute
  AdminTraceVideoIdRoute: typeof AdminTraceVideoIdRoute
  AuthErrorSplatRoute: typeof AuthErrorSplatRoute
  PrototypesCarouselsCarouselIdRoute: typeof PrototypesCarouselsCarouselIdRoute
  PrototypesImageEditorImageEditIdRoute: typeof PrototypesImageEditorImageEditIdRoute
  VideosVideoIdDebugRoute: typeof VideosVideoIdDebugRoute
  VideosVideoIdEditorRoute: typeof VideosVideoIdEditorRouteWithChildren
  VideosVideoIdStoryboardRoute: typeof VideosVideoIdStoryboardRoute
  AdminAdEngineIndexRoute: typeof AdminAdEngineIndexRoute
  PrototypesCarouselsIndexRoute: typeof PrototypesCarouselsIndexRoute
  PrototypesImageEditorIndexRoute: typeof PrototypesImageEditorIndexRoute
  PrototypesManwhaIndexRoute: typeof PrototypesManwhaIndexRoute
  PrototypesSocialMonitorIndexRoute: typeof PrototypesSocialMonitorIndexRoute
  VideosVideoIdIndexRoute: typeof VideosVideoIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/webhooks': {
      id: '/webhooks'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof WebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/voices': {
      id: '/voices'
      path: '/voices'
      fullPath: '/voices'
      preLoaderRoute: typeof VoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usage': {
      id: '/usage'
      path: '/usage'
      fullPath: '/usage'
      preLoaderRoute: typeof UsageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ugc-ai-avatar': {
      id: '/ugc-ai-avatar'
      path: '/ugc-ai-avatar'
      fullPath: '/ugc-ai-avatar'
      preLoaderRoute: typeof UgcAiAvatarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storyboard-exploration': {
      id: '/storyboard-exploration'
      path: '/storyboard-exploration'
      fullPath: '/storyboard-exploration'
      preLoaderRoute: typeof StoryboardExplorationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/social-accounts': {
      id: '/social-accounts'
      path: '/social-accounts'
      fullPath: '/social-accounts'
      preLoaderRoute: typeof SocialAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signout': {
      id: '/signout'
      path: '/signout'
      fullPath: '/signout'
      preLoaderRoute: typeof SignoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sentry-break': {
      id: '/sentry-break'
      path: '/sentry-break'
      fullPath: '/sentry-break'
      preLoaderRoute: typeof SentryBreakRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/schedule': {
      id: '/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof ScheduleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pdf': {
      id: '/pdf'
      path: '/pdf'
      fullPath: '/pdf'
      preLoaderRoute: typeof PdfRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-space': {
      id: '/media-space'
      path: '/media-space'
      fullPath: '/media-space'
      preLoaderRoute: typeof MediaSpaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-it-works': {
      id: '/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof HowItWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hooks': {
      id: '/hooks'
      path: '/hooks'
      fullPath: '/hooks'
      preLoaderRoute: typeof HooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/developers': {
      id: '/developers'
      path: '/developers'
      fullPath: '/developers'
      preLoaderRoute: typeof DevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deletion-request': {
      id: '/deletion-request'
      path: '/deletion-request'
      fullPath: '/deletion-request'
      preLoaderRoute: typeof DeletionRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/creator': {
      id: '/creator'
      path: '/creator'
      fullPath: '/creator'
      preLoaderRoute: typeof CreatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/b-roll': {
      id: '/b-roll'
      path: '/b-roll'
      fullPath: '/b-roll'
      preLoaderRoute: typeof BRollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automated-create': {
      id: '/automated-create'
      path: '/automated-create'
      fullPath: '/automated-create'
      preLoaderRoute: typeof AutomatedCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automated': {
      id: '/automated'
      path: '/automated'
      fullPath: '/automated'
      preLoaderRoute: typeof AutomatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audio': {
      id: '/audio'
      path: '/audio'
      fullPath: '/audio'
      preLoaderRoute: typeof AudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-library': {
      id: '/asset-library'
      path: '/asset-library'
      fullPath: '/asset-library'
      preLoaderRoute: typeof AssetLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-keys': {
      id: '/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof ApiKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ad-library': {
      id: '/ad-library'
      path: '/ad-library'
      fullPath: '/ad-library'
      preLoaderRoute: typeof AdLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$modelSlug': {
      id: '/$modelSlug'
      path: '/$modelSlug'
      fullPath: '/$modelSlug'
      preLoaderRoute: typeof ModelSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viral/': {
      id: '/viral/'
      path: '/viral'
      fullPath: '/viral'
      preLoaderRoute: typeof ViralIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos/': {
      id: '/videos/'
      path: '/videos'
      fullPath: '/videos'
      preLoaderRoute: typeof VideosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tutorial/': {
      id: '/tutorial/'
      path: '/tutorial'
      fullPath: '/tutorial'
      preLoaderRoute: typeof TutorialIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/': {
      id: '/tools/'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/': {
      id: '/templates/'
      path: '/templates'
      fullPath: '/templates'
      preLoaderRoute: typeof TemplatesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/success-stories/': {
      id: '/success-stories/'
      path: '/success-stories'
      fullPath: '/success-stories'
      preLoaderRoute: typeof SuccessStoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-space/': {
      id: '/media-space/'
      path: '/'
      fullPath: '/media-space/'
      preLoaderRoute: typeof MediaSpaceIndexRouteImport
      parentRoute: typeof MediaSpaceRoute
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/': {
      id: '/auth/'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viral/pricing': {
      id: '/viral/pricing'
      path: '/viral/pricing'
      fullPath: '/viral/pricing'
      preLoaderRoute: typeof ViralPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v/$linkId': {
      id: '/v/$linkId'
      path: '/v/$linkId'
      fullPath: '/v/$linkId'
      preLoaderRoute: typeof VLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/video-effects': {
      id: '/tools/video-effects'
      path: '/tools/video-effects'
      fullPath: '/tools/video-effects'
      preLoaderRoute: typeof ToolsVideoEffectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/veo3-generator': {
      id: '/tools/veo3-generator'
      path: '/tools/veo3-generator'
      fullPath: '/tools/veo3-generator'
      preLoaderRoute: typeof ToolsVeo3GeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/style-transfer': {
      id: '/tools/style-transfer'
      path: '/tools/style-transfer'
      fullPath: '/tools/style-transfer'
      preLoaderRoute: typeof ToolsStyleTransferRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/script-writer': {
      id: '/tools/script-writer'
      path: '/tools/script-writer'
      fullPath: '/tools/script-writer'
      preLoaderRoute: typeof ToolsScriptWriterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/prompt-hub': {
      id: '/tools/prompt-hub'
      path: '/tools/prompt-hub'
      fullPath: '/tools/prompt-hub'
      preLoaderRoute: typeof ToolsPromptHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/infinitetalk-demo': {
      id: '/tools/infinitetalk-demo'
      path: '/tools/infinitetalk-demo'
      fullPath: '/tools/infinitetalk-demo'
      preLoaderRoute: typeof ToolsInfinitetalkDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/image-upscaler': {
      id: '/tools/image-upscaler'
      path: '/tools/image-upscaler'
      fullPath: '/tools/image-upscaler'
      preLoaderRoute: typeof ToolsImageUpscalerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/image-transformer': {
      id: '/tools/image-transformer'
      path: '/tools/image-transformer'
      fullPath: '/tools/image-transformer'
      preLoaderRoute: typeof ToolsImageTransformerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/image-resizer': {
      id: '/tools/image-resizer'
      path: '/tools/image-resizer'
      fullPath: '/tools/image-resizer'
      preLoaderRoute: typeof ToolsImageResizerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/background-remover': {
      id: '/tools/background-remover'
      path: '/tools/background-remover'
      fullPath: '/tools/background-remover'
      preLoaderRoute: typeof ToolsBackgroundRemoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/avatar-library': {
      id: '/tools/avatar-library'
      path: '/tools/avatar-library'
      fullPath: '/tools/avatar-library'
      preLoaderRoute: typeof ToolsAvatarLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/avatar-ad-generator': {
      id: '/tools/avatar-ad-generator'
      path: '/tools/avatar-ad-generator'
      fullPath: '/tools/avatar-ad-generator'
      preLoaderRoute: typeof ToolsAvatarAdGeneratorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/asset-library': {
      id: '/tools/asset-library'
      path: '/tools/asset-library'
      fullPath: '/tools/asset-library'
      preLoaderRoute: typeof ToolsAssetLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/ai-voiceover': {
      id: '/tools/ai-voiceover'
      path: '/tools/ai-voiceover'
      fullPath: '/tools/ai-voiceover'
      preLoaderRoute: typeof ToolsAiVoiceoverRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/ai-sound-effects': {
      id: '/tools/ai-sound-effects'
      path: '/tools/ai-sound-effects'
      fullPath: '/tools/ai-sound-effects'
      preLoaderRoute: typeof ToolsAiSoundEffectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/ai-avatar': {
      id: '/tools/ai-avatar'
      path: '/tools/ai-avatar'
      fullPath: '/tools/ai-avatar'
      preLoaderRoute: typeof ToolsAiAvatarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/ad-scraper': {
      id: '/tools/ad-scraper'
      path: '/tools/ad-scraper'
      fullPath: '/tools/ad-scraper'
      preLoaderRoute: typeof ToolsAdScraperRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/$id': {
      id: '/tools/$id'
      path: '/tools/$id'
      fullPath: '/tools/$id'
      preLoaderRoute: typeof ToolsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/reddit-story': {
      id: '/templates/reddit-story'
      path: '/templates/reddit-story'
      fullPath: '/templates/reddit-story'
      preLoaderRoute: typeof TemplatesRedditStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/pov-story': {
      id: '/templates/pov-story'
      path: '/templates/pov-story'
      fullPath: '/templates/pov-story'
      preLoaderRoute: typeof TemplatesPovStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/genz-avatars': {
      id: '/templates/genz-avatars'
      path: '/templates/genz-avatars'
      fullPath: '/templates/genz-avatars'
      preLoaderRoute: typeof TemplatesGenzAvatarsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/fake-text': {
      id: '/templates/fake-text'
      path: '/templates/fake-text'
      fullPath: '/templates/fake-text'
      preLoaderRoute: typeof TemplatesFakeTextRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/templates/ai-story': {
      id: '/templates/ai-story'
      path: '/templates/ai-story'
      fullPath: '/templates/ai-story'
      preLoaderRoute: typeof TemplatesAiStoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/invite': {
      id: '/team/invite'
      path: '/team/invite'
      fullPath: '/team/invite'
      preLoaderRoute: typeof TeamInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/series/$seriesId': {
      id: '/series/$seriesId'
      path: '/series/$seriesId'
      fullPath: '/series/$seriesId'
      preLoaderRoute: typeof SeriesSeriesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-space/workflows': {
      id: '/media-space/workflows'
      path: '/workflows'
      fullPath: '/media-space/workflows'
      preLoaderRoute: typeof MediaSpaceWorkflowsRouteImport
      parentRoute: typeof MediaSpaceRoute
    }
    '/media-space/boards': {
      id: '/media-space/boards'
      path: '/boards'
      fullPath: '/media-space/boards'
      preLoaderRoute: typeof MediaSpaceBoardsRouteImport
      parentRoute: typeof MediaSpaceRoute
    }
    '/embed/edit': {
      id: '/embed/edit'
      path: '/embed/edit'
      fullPath: '/embed/edit'
      preLoaderRoute: typeof EmbedEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/video': {
      id: '/create/video'
      path: '/create/video'
      fullPath: '/create/video'
      preLoaderRoute: typeof CreateVideoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/ugc-templates': {
      id: '/create/ugc-templates'
      path: '/create/ugc-templates'
      fullPath: '/create/ugc-templates'
      preLoaderRoute: typeof CreateUgcTemplatesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/ugc-avatars': {
      id: '/create/ugc-avatars'
      path: '/create/ugc-avatars'
      fullPath: '/create/ugc-avatars'
      preLoaderRoute: typeof CreateUgcAvatarsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/ugc': {
      id: '/create/ugc'
      path: '/create/ugc'
      fullPath: '/create/ugc'
      preLoaderRoute: typeof CreateUgcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/image': {
      id: '/create/image'
      path: '/create/image'
      fullPath: '/create/image'
      preLoaderRoute: typeof CreateImageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/edit': {
      id: '/create/edit'
      path: '/create/edit'
      fullPath: '/create/edit'
      preLoaderRoute: typeof CreateEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/captions': {
      id: '/create/captions'
      path: '/create/captions'
      fullPath: '/create/captions'
      preLoaderRoute: typeof CreateCaptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/audio': {
      id: '/create/audio'
      path: '/create/audio'
      fullPath: '/create/audio'
      preLoaderRoute: typeof CreateAudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/ad-studio': {
      id: '/create/ad-studio'
      path: '/create/ad-studio'
      fullPath: '/create/ad-studio'
      preLoaderRoute: typeof CreateAdStudioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/admin': {
      id: '/blog/admin'
      path: '/blog/admin'
      fullPath: '/blog/admin'
      preLoaderRoute: typeof BlogAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signout': {
      id: '/auth/signout'
      path: '/auth/signout'
      fullPath: '/auth/signout'
      preLoaderRoute: typeof AuthSignoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/auth/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-library/$assetId': {
      id: '/asset-library/$assetId'
      path: '/$assetId'
      fullPath: '/asset-library/$assetId'
      preLoaderRoute: typeof AssetLibraryAssetIdRouteImport
      parentRoute: typeof AssetLibraryRoute
    }
    '/ads/static': {
      id: '/ads/static'
      path: '/ads/static'
      fullPath: '/ads/static'
      preLoaderRoute: typeof AdsStaticRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/voices': {
      id: '/admin/voices'
      path: '/admin/voices'
      fullPath: '/admin/voices'
      preLoaderRoute: typeof AdminVoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/videos': {
      id: '/admin/videos'
      path: '/admin/videos'
      fullPath: '/admin/videos'
      preLoaderRoute: typeof AdminVideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tools': {
      id: '/admin/tools'
      path: '/admin/tools'
      fullPath: '/admin/tools'
      preLoaderRoute: typeof AdminToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/teams': {
      id: '/admin/teams'
      path: '/admin/teams'
      fullPath: '/admin/teams'
      preLoaderRoute: typeof AdminTeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/static-ads': {
      id: '/admin/static-ads'
      path: '/admin/static-ads'
      fullPath: '/admin/static-ads'
      preLoaderRoute: typeof AdminStaticAdsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/signin': {
      id: '/admin/signin'
      path: '/admin/signin'
      fullPath: '/admin/signin'
      preLoaderRoute: typeof AdminSigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/series': {
      id: '/admin/series'
      path: '/admin/series'
      fullPath: '/admin/series'
      preLoaderRoute: typeof AdminSeriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/scheduledPosts': {
      id: '/admin/scheduledPosts'
      path: '/admin/scheduledPosts'
      fullPath: '/admin/scheduledPosts'
      preLoaderRoute: typeof AdminScheduledPostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/render-lab': {
      id: '/admin/render-lab'
      path: '/admin/render-lab'
      fullPath: '/admin/render-lab'
      preLoaderRoute: typeof AdminRenderLabRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/admin/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/presets': {
      id: '/admin/presets'
      path: '/admin/presets'
      fullPath: '/admin/presets'
      preLoaderRoute: typeof AdminPresetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pipelines': {
      id: '/admin/pipelines'
      path: '/admin/pipelines'
      fullPath: '/admin/pipelines'
      preLoaderRoute: typeof AdminPipelinesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/model-registry': {
      id: '/admin/model-registry'
      path: '/admin/model-registry'
      fullPath: '/admin/model-registry'
      preLoaderRoute: typeof AdminModelRegistryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/model-pricing': {
      id: '/admin/model-pricing'
      path: '/admin/model-pricing'
      fullPath: '/admin/model-pricing'
      preLoaderRoute: typeof AdminModelPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/mastra': {
      id: '/admin/mastra'
      path: '/admin/mastra'
      fullPath: '/admin/mastra'
      preLoaderRoute: typeof AdminMastraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/kev': {
      id: '/admin/kev'
      path: '/admin/kev'
      fullPath: '/admin/kev'
      preLoaderRoute: typeof AdminKevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/feedback': {
      id: '/admin/feedback'
      path: '/admin/feedback'
      fullPath: '/admin/feedback'
      preLoaderRoute: typeof AdminFeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/experiments': {
      id: '/admin/experiments'
      path: '/admin/experiments'
      fullPath: '/admin/experiments'
      preLoaderRoute: typeof AdminExperimentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/evals': {
      id: '/admin/evals'
      path: '/admin/evals'
      fullPath: '/admin/evals'
      preLoaderRoute: typeof AdminEvalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email': {
      id: '/admin/email'
      path: '/admin/email'
      fullPath: '/admin/email'
      preLoaderRoute: typeof AdminEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/editor-effects': {
      id: '/admin/editor-effects'
      path: '/admin/editor-effects'
      fullPath: '/admin/editor-effects'
      preLoaderRoute: typeof AdminEditorEffectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/content-seeds': {
      id: '/admin/content-seeds'
      path: '/admin/content-seeds'
      fullPath: '/admin/content-seeds'
      preLoaderRoute: typeof AdminContentSeedsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/brands': {
      id: '/admin/brands'
      path: '/admin/brands'
      fullPath: '/admin/brands'
      preLoaderRoute: typeof AdminBrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/benchmarks': {
      id: '/admin/benchmarks'
      path: '/admin/benchmarks'
      fullPath: '/admin/benchmarks'
      preLoaderRoute: typeof AdminBenchmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/avatars': {
      id: '/admin/avatars'
      path: '/admin/avatars'
      fullPath: '/admin/avatars'
      preLoaderRoute: typeof AdminAvatarsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/assets': {
      id: '/admin/assets'
      path: '/admin/assets'
      fullPath: '/admin/assets'
      preLoaderRoute: typeof AdminAssetsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/asset-jobs': {
      id: '/admin/asset-jobs'
      path: '/admin/asset-jobs'
      fullPath: '/admin/asset-jobs'
      preLoaderRoute: typeof AdminAssetJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ads-performance': {
      id: '/admin/ads-performance'
      path: '/admin/ads-performance'
      fullPath: '/admin/ads-performance'
      preLoaderRoute: typeof AdminAdsPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ad-library': {
      id: '/admin/ad-library'
      path: '/admin/ad-library'
      fullPath: '/admin/ad-library'
      preLoaderRoute: typeof AdminAdLibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ad-library/$adId': {
      id: '/ad-library/$adId'
      path: '/$adId'
      fullPath: '/ad-library/$adId'
      preLoaderRoute: typeof AdLibraryAdIdRouteImport
      parentRoute: typeof AdLibraryRoute
    }
    '/videos/$videoId/': {
      id: '/videos/$videoId/'
      path: '/videos/$videoId'
      fullPath: '/videos/$videoId'
      preLoaderRoute: typeof VideosVideoIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/social-monitor/': {
      id: '/prototypes/social-monitor/'
      path: '/prototypes/social-monitor'
      fullPath: '/prototypes/social-monitor'
      preLoaderRoute: typeof PrototypesSocialMonitorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/manwha/': {
      id: '/prototypes/manwha/'
      path: '/prototypes/manwha'
      fullPath: '/prototypes/manwha'
      preLoaderRoute: typeof PrototypesManwhaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/image-editor/': {
      id: '/prototypes/image-editor/'
      path: '/prototypes/image-editor'
      fullPath: '/prototypes/image-editor'
      preLoaderRoute: typeof PrototypesImageEditorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/carousels/': {
      id: '/prototypes/carousels/'
      path: '/prototypes/carousels'
      fullPath: '/prototypes/carousels'
      preLoaderRoute: typeof PrototypesCarouselsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ad-engine/': {
      id: '/admin/ad-engine/'
      path: '/admin/ad-engine'
      fullPath: '/admin/ad-engine'
      preLoaderRoute: typeof AdminAdEngineIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos/$videoId/storyboard': {
      id: '/videos/$videoId/storyboard'
      path: '/videos/$videoId/storyboard'
      fullPath: '/videos/$videoId/storyboard'
      preLoaderRoute: typeof VideosVideoIdStoryboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos/$videoId/editor': {
      id: '/videos/$videoId/editor'
      path: '/videos/$videoId/editor'
      fullPath: '/videos/$videoId/editor'
      preLoaderRoute: typeof VideosVideoIdEditorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos/$videoId/debug': {
      id: '/videos/$videoId/debug'
      path: '/videos/$videoId/debug'
      fullPath: '/videos/$videoId/debug'
      preLoaderRoute: typeof VideosVideoIdDebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/image-editor/$imageEditId': {
      id: '/prototypes/image-editor/$imageEditId'
      path: '/prototypes/image-editor/$imageEditId'
      fullPath: '/prototypes/image-editor/$imageEditId'
      preLoaderRoute: typeof PrototypesImageEditorImageEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prototypes/carousels/$carouselId': {
      id: '/prototypes/carousels/$carouselId'
      path: '/prototypes/carousels/$carouselId'
      fullPath: '/prototypes/carousels/$carouselId'
      preLoaderRoute: typeof PrototypesCarouselsCarouselIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media-space/board/$boardId': {
      id: '/media-space/board/$boardId'
      path: '/board/$boardId'
      fullPath: '/media-space/board/$boardId'
      preLoaderRoute: typeof MediaSpaceBoardBoardIdRouteImport
      parentRoute: typeof MediaSpaceRoute
    }
    '/media-space/asset/$assetId': {
      id: '/media-space/asset/$assetId'
      path: '/asset/$assetId'
      fullPath: '/media-space/asset/$assetId'
      preLoaderRoute: typeof MediaSpaceAssetAssetIdRouteImport
      parentRoute: typeof MediaSpaceRoute
    }
    '/create/captions/$videoId': {
      id: '/create/captions/$videoId'
      path: '/$videoId'
      fullPath: '/create/captions/$videoId'
      preLoaderRoute: typeof CreateCaptionsVideoIdRouteImport
      parentRoute: typeof CreateCaptionsRoute
    }
    '/auth/error/$': {
      id: '/auth/error/$'
      path: '/auth/error/$'
      fullPath: '/auth/error/$'
      preLoaderRoute: typeof AuthErrorSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/trace/$videoId': {
      id: '/admin/trace/$videoId'
      path: '/admin/trace/$videoId'
      fullPath: '/admin/trace/$videoId'
      preLoaderRoute: typeof AdminTraceVideoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/team/$id': {
      id: '/admin/team/$id'
      path: '/admin/team/$id'
      fullPath: '/admin/team/$id'
      preLoaderRoute: typeof AdminTeamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pipelines/$executionId': {
      id: '/admin/pipelines/$executionId'
      path: '/$executionId'
      fullPath: '/admin/pipelines/$executionId'
      preLoaderRoute: typeof AdminPipelinesExecutionIdRouteImport
      parentRoute: typeof AdminPipelinesRoute
    }
    '/admin/asset-jobs/$id': {
      id: '/admin/asset-jobs/$id'
      path: '/$id'
      fullPath: '/admin/asset-jobs/$id'
      preLoaderRoute: typeof AdminAssetJobsIdRouteImport
      parentRoute: typeof AdminAssetJobsRoute
    }
    '/admin/ads-performance/meta-callback': {
      id: '/admin/ads-performance/meta-callback'
      path: '/meta-callback'
      fullPath: '/admin/ads-performance/meta-callback'
      preLoaderRoute: typeof AdminAdsPerformanceMetaCallbackRouteImport
      parentRoute: typeof AdminAdsPerformanceRoute
    }
    '/admin/ad-engine/review': {
      id: '/admin/ad-engine/review'
      path: '/admin/ad-engine/review'
      fullPath: '/admin/ad-engine/review'
      preLoaderRoute: typeof AdminAdEngineReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ad-engine/formats': {
      id: '/admin/ad-engine/formats'
      path: '/admin/ad-engine/formats'
      fullPath: '/admin/ad-engine/formats'
      preLoaderRoute: typeof AdminAdEngineFormatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ad-engine/$videoId': {
      id: '/admin/ad-engine/$videoId'
      path: '/admin/ad-engine/$videoId'
      fullPath: '/admin/ad-engine/$videoId'
      preLoaderRoute: typeof AdminAdEngineVideoIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/videos/$videoId/editor/': {
      id: '/videos/$videoId/editor/'
      path: '/'
      fullPath: '/videos/$videoId/editor/'
      preLoaderRoute: typeof VideosVideoIdEditorIndexRouteImport
      parentRoute: typeof VideosVideoIdEditorRoute
    }
    '/videos/$videoId/editor/reddit-story': {
      id: '/videos/$videoId/editor/reddit-story'
      path: '/reddit-story'
      fullPath: '/videos/$videoId/editor/reddit-story'
      preLoaderRoute: typeof VideosVideoIdEditorRedditStoryRouteImport
      parentRoute: typeof VideosVideoIdEditorRoute
    }
    '/videos/$videoId/editor/genz-avatars': {
      id: '/videos/$videoId/editor/genz-avatars'
      path: '/genz-avatars'
      fullPath: '/videos/$videoId/editor/genz-avatars'
      preLoaderRoute: typeof VideosVideoIdEditorGenzAvatarsRouteImport
      parentRoute: typeof VideosVideoIdEditorRoute
    }
    '/videos/$videoId/editor/fake-text': {
      id: '/videos/$videoId/editor/fake-text'
      path: '/fake-text'
      fullPath: '/videos/$videoId/editor/fake-text'
      preLoaderRoute: typeof VideosVideoIdEditorFakeTextRouteImport
      parentRoute: typeof VideosVideoIdEditorRoute
    }
  }
}

interface AdLibraryRouteChildren {
  AdLibraryAdIdRoute: typeof AdLibraryAdIdRoute
}

const AdLibraryRouteChildren: AdLibraryRouteChildren = {
  AdLibraryAdIdRoute: AdLibraryAdIdRoute,
}

const AdLibraryRouteWithChildren = AdLibraryRoute._addFileChildren(
  AdLibraryRouteChildren,
)

interface AssetLibraryRouteChildren {
  AssetLibraryAssetIdRoute: typeof AssetLibraryAssetIdRoute
}

const AssetLibraryRouteChildren: AssetLibraryRouteChildren = {
  AssetLibraryAssetIdRoute: AssetLibraryAssetIdRoute,
}

const AssetLibraryRouteWithChildren = AssetLibraryRoute._addFileChildren(
  AssetLibraryRouteChildren,
)

interface MediaSpaceRouteChildren {
  MediaSpaceBoardsRoute: typeof MediaSpaceBoardsRoute
  MediaSpaceWorkflowsRoute: typeof MediaSpaceWorkflowsRoute
  MediaSpaceIndexRoute: typeof MediaSpaceIndexRoute
  MediaSpaceAssetAssetIdRoute: typeof MediaSpaceAssetAssetIdRoute
  MediaSpaceBoardBoardIdRoute: typeof MediaSpaceBoardBoardIdRoute
}

const MediaSpaceRouteChildren: MediaSpaceRouteChildren = {
  MediaSpaceBoardsRoute: MediaSpaceBoardsRoute,
  MediaSpaceWorkflowsRoute: MediaSpaceWorkflowsRoute,
  MediaSpaceIndexRoute: MediaSpaceIndexRoute,
  MediaSpaceAssetAssetIdRoute: MediaSpaceAssetAssetIdRoute,
  MediaSpaceBoardBoardIdRoute: MediaSpaceBoardBoardIdRoute,
}

const MediaSpaceRouteWithChildren = MediaSpaceRoute._addFileChildren(
  MediaSpaceRouteChildren,
)

interface AdminAdsPerformanceRouteChildren {
  AdminAdsPerformanceMetaCallbackRoute: typeof AdminAdsPerformanceMetaCallbackRoute
}

const AdminAdsPerformanceRouteChildren: AdminAdsPerformanceRouteChildren = {
  AdminAdsPerformanceMetaCallbackRoute: AdminAdsPerformanceMetaCallbackRoute,
}

const AdminAdsPerformanceRouteWithChildren =
  AdminAdsPerformanceRoute._addFileChildren(AdminAdsPerformanceRouteChildren)

interface AdminAssetJobsRouteChildren {
  AdminAssetJobsIdRoute: typeof AdminAssetJobsIdRoute
}

const AdminAssetJobsRouteChildren: AdminAssetJobsRouteChildren = {
  AdminAssetJobsIdRoute: AdminAssetJobsIdRoute,
}

const AdminAssetJobsRouteWithChildren = AdminAssetJobsRoute._addFileChildren(
  AdminAssetJobsRouteChildren,
)

interface AdminPipelinesRouteChildren {
  AdminPipelinesExecutionIdRoute: typeof AdminPipelinesExecutionIdRoute
}

const AdminPipelinesRouteChildren: AdminPipelinesRouteChildren = {
  AdminPipelinesExecutionIdRoute: AdminPipelinesExecutionIdRoute,
}

const AdminPipelinesRouteWithChildren = AdminPipelinesRoute._addFileChildren(
  AdminPipelinesRouteChildren,
)

interface CreateCaptionsRouteChildren {
  CreateCaptionsVideoIdRoute: typeof CreateCaptionsVideoIdRoute
}

const CreateCaptionsRouteChildren: CreateCaptionsRouteChildren = {
  CreateCaptionsVideoIdRoute: CreateCaptionsVideoIdRoute,
}

const CreateCaptionsRouteWithChildren = CreateCaptionsRoute._addFileChildren(
  CreateCaptionsRouteChildren,
)

interface VideosVideoIdEditorRouteChildren {
  VideosVideoIdEditorFakeTextRoute: typeof VideosVideoIdEditorFakeTextRoute
  VideosVideoIdEditorGenzAvatarsRoute: typeof VideosVideoIdEditorGenzAvatarsRoute
  VideosVideoIdEditorRedditStoryRoute: typeof VideosVideoIdEditorRedditStoryRoute
  VideosVideoIdEditorIndexRoute: typeof VideosVideoIdEditorIndexRoute
}

const VideosVideoIdEditorRouteChildren: VideosVideoIdEditorRouteChildren = {
  VideosVideoIdEditorFakeTextRoute: VideosVideoIdEditorFakeTextRoute,
  VideosVideoIdEditorGenzAvatarsRoute: VideosVideoIdEditorGenzAvatarsRoute,
  VideosVideoIdEditorRedditStoryRoute: VideosVideoIdEditorRedditStoryRoute,
  VideosVideoIdEditorIndexRoute: VideosVideoIdEditorIndexRoute,
}

const VideosVideoIdEditorRouteWithChildren =
  VideosVideoIdEditorRoute._addFileChildren(VideosVideoIdEditorRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ModelSlugRoute: ModelSlugRoute,
  R404Route: R404Route,
  AccountRoute: AccountRoute,
  AdLibraryRoute: AdLibraryRouteWithChildren,
  ApiKeysRoute: ApiKeysRoute,
  AssetLibraryRoute: AssetLibraryRouteWithChildren,
  AudioRoute: AudioRoute,
  AutomatedRoute: AutomatedRoute,
  AutomatedCreateRoute: AutomatedCreateRoute,
  BRollRoute: BRollRoute,
  BillingRoute: BillingRoute,
  BrandsRoute: BrandsRoute,
  ChangelogRoute: ChangelogRoute,
  CreatorRoute: CreatorRoute,
  DeletionRequestRoute: DeletionRequestRoute,
  DevelopersRoute: DevelopersRoute,
  DocsRoute: DocsRoute,
  HomeRoute: HomeRoute,
  HooksRoute: HooksRoute,
  HowItWorksRoute: HowItWorksRoute,
  MediaSpaceRoute: MediaSpaceRouteWithChildren,
  PdfRoute: PdfRoute,
  PricingRoute: PricingRoute,
  PrivacyRoute: PrivacyRoute,
  ProductsRoute: ProductsRoute,
  ScheduleRoute: ScheduleRoute,
  SentryBreakRoute: SentryBreakRoute,
  SignoutRoute: SignoutRoute,
  SocialAccountsRoute: SocialAccountsRoute,
  StoryboardExplorationRoute: StoryboardExplorationRoute,
  TermsRoute: TermsRoute,
  UgcAiAvatarRoute: UgcAiAvatarRoute,
  UsageRoute: UsageRoute,
  VoicesRoute: VoicesRoute,
  WebhooksRoute: WebhooksRoute,
  AdminAdLibraryRoute: AdminAdLibraryRoute,
  AdminAdsPerformanceRoute: AdminAdsPerformanceRouteWithChildren,
  AdminAssetJobsRoute: AdminAssetJobsRouteWithChildren,
  AdminAssetsRoute: AdminAssetsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminAvatarsRoute: AdminAvatarsRoute,
  AdminBenchmarksRoute: AdminBenchmarksRoute,
  AdminBrandsRoute: AdminBrandsRoute,
  AdminContentSeedsRoute: AdminContentSeedsRoute,
  AdminEditorEffectsRoute: AdminEditorEffectsRoute,
  AdminEmailRoute: AdminEmailRoute,
  AdminEvalsRoute: AdminEvalsRoute,
  AdminExperimentsRoute: AdminExperimentsRoute,
  AdminFeedbackRoute: AdminFeedbackRoute,
  AdminKevRoute: AdminKevRoute,
  AdminMastraRoute: AdminMastraRoute,
  AdminModelPricingRoute: AdminModelPricingRoute,
  AdminModelRegistryRoute: AdminModelRegistryRoute,
  AdminPipelinesRoute: AdminPipelinesRouteWithChildren,
  AdminPresetsRoute: AdminPresetsRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminRenderLabRoute: AdminRenderLabRoute,
  AdminScheduledPostsRoute: AdminScheduledPostsRoute,
  AdminSeriesRoute: AdminSeriesRoute,
  AdminSigninRoute: AdminSigninRoute,
  AdminStaticAdsRoute: AdminStaticAdsRoute,
  AdminTeamsRoute: AdminTeamsRoute,
  AdminToolsRoute: AdminToolsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminVideosRoute: AdminVideosRoute,
  AdminVoicesRoute: AdminVoicesRoute,
  AdsStaticRoute: AdsStaticRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignoutRoute: AuthSignoutRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  BlogSlugRoute: BlogSlugRoute,
  BlogAdminRoute: BlogAdminRoute,
  CreateAdStudioRoute: CreateAdStudioRoute,
  CreateAudioRoute: CreateAudioRoute,
  CreateCaptionsRoute: CreateCaptionsRouteWithChildren,
  CreateEditRoute: CreateEditRoute,
  CreateImageRoute: CreateImageRoute,
  CreateUgcRoute: CreateUgcRoute,
  CreateUgcAvatarsRoute: CreateUgcAvatarsRoute,
  CreateUgcTemplatesRoute: CreateUgcTemplatesRoute,
  CreateVideoRoute: CreateVideoRoute,
  EmbedEditRoute: EmbedEditRoute,
  SeriesSeriesIdRoute: SeriesSeriesIdRoute,
  TeamInviteRoute: TeamInviteRoute,
  TemplatesAiStoryRoute: TemplatesAiStoryRoute,
  TemplatesFakeTextRoute: TemplatesFakeTextRoute,
  TemplatesGenzAvatarsRoute: TemplatesGenzAvatarsRoute,
  TemplatesPovStoryRoute: TemplatesPovStoryRoute,
  TemplatesRedditStoryRoute: TemplatesRedditStoryRoute,
  ToolsIdRoute: ToolsIdRoute,
  ToolsAdScraperRoute: ToolsAdScraperRoute,
  ToolsAiAvatarRoute: ToolsAiAvatarRoute,
  ToolsAiSoundEffectsRoute: ToolsAiSoundEffectsRoute,
  ToolsAiVoiceoverRoute: ToolsAiVoiceoverRoute,
  ToolsAssetLibraryRoute: ToolsAssetLibraryRoute,
  ToolsAvatarAdGeneratorRoute: ToolsAvatarAdGeneratorRoute,
  ToolsAvatarLibraryRoute: ToolsAvatarLibraryRoute,
  ToolsBackgroundRemoverRoute: ToolsBackgroundRemoverRoute,
  ToolsImageResizerRoute: ToolsImageResizerRoute,
  ToolsImageTransformerRoute: ToolsImageTransformerRoute,
  ToolsImageUpscalerRoute: ToolsImageUpscalerRoute,
  ToolsInfinitetalkDemoRoute: ToolsInfinitetalkDemoRoute,
  ToolsPromptHubRoute: ToolsPromptHubRoute,
  ToolsScriptWriterRoute: ToolsScriptWriterRoute,
  ToolsStyleTransferRoute: ToolsStyleTransferRoute,
  ToolsVeo3GeneratorRoute: ToolsVeo3GeneratorRoute,
  ToolsVideoEffectsRoute: ToolsVideoEffectsRoute,
  VLinkIdRoute: VLinkIdRoute,
  ViralPricingRoute: ViralPricingRoute,
  AdminIndexRoute: AdminIndexRoute,
  AuthIndexRoute: AuthIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  CreateIndexRoute: CreateIndexRoute,
  SuccessStoriesIndexRoute: SuccessStoriesIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
  TemplatesIndexRoute: TemplatesIndexRoute,
  ToolsIndexRoute: ToolsIndexRoute,
  TutorialIndexRoute: TutorialIndexRoute,
  VideosIndexRoute: VideosIndexRoute,
  ViralIndexRoute: ViralIndexRoute,
  AdminAdEngineVideoIdRoute: AdminAdEngineVideoIdRoute,
  AdminAdEngineFormatsRoute: AdminAdEngineFormatsRoute,
  AdminAdEngineReviewRoute: AdminAdEngineReviewRoute,
  AdminTeamIdRoute: AdminTeamIdRoute,
  AdminTraceVideoIdRoute: AdminTraceVideoIdRoute,
  AuthErrorSplatRoute: AuthErrorSplatRoute,
  PrototypesCarouselsCarouselIdRoute: PrototypesCarouselsCarouselIdRoute,
  PrototypesImageEditorImageEditIdRoute: PrototypesImageEditorImageEditIdRoute,
  VideosVideoIdDebugRoute: VideosVideoIdDebugRoute,
  VideosVideoIdEditorRoute: VideosVideoIdEditorRouteWithChildren,
  VideosVideoIdStoryboardRoute: VideosVideoIdStoryboardRoute,
  AdminAdEngineIndexRoute: AdminAdEngineIndexRoute,
  PrototypesCarouselsIndexRoute: PrototypesCarouselsIndexRoute,
  PrototypesImageEditorIndexRoute: PrototypesImageEditorIndexRoute,
  PrototypesManwhaIndexRoute: PrototypesManwhaIndexRoute,
  PrototypesSocialMonitorIndexRoute: PrototypesSocialMonitorIndexRoute,
  VideosVideoIdIndexRoute: VideosVideoIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
